import { compararPrecoComTaxas } from "../utils/precoTaxas";
import { emailPedidoConcluido } from "../utils/email";
import { pagoNoCaixa, repassePrevisto } from "../utils/vendaOnline";
import { dataPedido } from "../utils/pedidosPainel";
import "./pedidos/pedidos-workspace.css";
import { podeExcluirPedido, registrarPerdaPedido, salvarAlteracoesPedido, excluirPedidoRascunho, espelharPedidosSite, mudarStatusPedido, registrarPagamentoPedido, estornarPagamentosPedido, confirmarRepassePedido } from "../utils/pedidosPersistencia";
import { recalcularVendaOnlinePedido, validarVendaOnline } from "../utils/vendaOnline";
import { CommerceDialog, CommerceTabs, CommercePanel } from "./commerce/CommerceDialog";
import { useState, useEffect, useRef } from "react";
import { CupomVenda } from "./CupomVenda";
import { descontarPedido } from "../utils/cupomVenda";
import { registrarRecebimentoComCupom } from "../utils/cupomVendaFirebase";
import { getDoc, doc, collection, onSnapshot } from "firebase/firestore";
import QRCode from "qrcode";
import { db } from "../firebase";
import { gerarPixPayload } from "../utils/pix";
import { toast } from "../hooks/useToast";
import {C, withAlpha } from "../constants/theme";
import { CORES_PRESET } from "../constants/colors";
import { fbList, fbAdd, fbUpdate, fbWatch } from "../hooks/useFirebase";
import { useConfirm } from "../hooks/useConfirm";
import { calcCustoPedido, custoUnitarioProduto } from "../utils/calcCusto";
import { calcPagamento } from "../utils/pagamento";
import { arredondarHoras } from "../utils/horas";
import { Badge } from "./ui/Badge";
import { Card } from "./ui/Card";
import { Inp } from "./ui/Inp";
import { Sel } from "./ui/Sel";
import { Btn } from "./ui/Btn";
import { ChatPedido } from "./ChatPedido";
import { STATUS_PEDIDO, normalizarStatus, statusInfo, proximoStatus } from "../constants/statusPedido";
import { abrirNoBambuStudio, baixarArquivo } from "../utils/arquivos3d";
import { getUser } from "../utils/sessao";
import { useTaxasLojas } from "../hooks/useTaxasLojas";
import { listaMaquininhas } from "../constants/maquininhas";
import { VENDA_VAZIA, listaCanais, iconeCanal, ehVendaOnline, calcularVendaOnline, vendaOnlineParaSalvar, vendaParaForm, aplicarPadraoDoCanal, padraoDoPedido, novoCusto, embalagemDoPedido, temPadrao } from "../utils/vendaOnline";
import { useVendaOnlineConfig } from "../hooks/useVendaOnlineConfig";
import { SeletorCanal, VendaOnlineSecao, ResumoVendaOnline, ModalRepasse } from "./pedidos/VendaOnlineSecao";
import { PixMercadoPago, useStatusMercadoPago } from "./pedidos/PixMercadoPago";
import { mpHabilitado, mercadoPagoEmUso } from "../utils/mercadoPago";
import { CobrancaOnline } from "./pedidos/CobrancaOnline";
import { pagamentosExtrasHabilitados, pixManualNosPedidos, useStatusProvedor } from "../utils/pagamentos";
import "./operacao.css";

// Mapeamentos de status centralizados em constants/statusPedido.js

const MOTIVOS_PERDA = ["Descolou da mesa","Entupimento do bico","Acabou o filamento","Queda de energia","Erro no modelo/fatiamento","Empenamento (warping)","Outro"];

// Espelha pedidos da loja online para "pedidos" e mantém o status sincronizado
const fmtData = valor => dataPedido(valor)?.toLocaleDateString("pt-BR") || "—";
const fmtDataHora = valor => dataPedido(valor)?.toLocaleString("pt-BR", { day:"2-digit", month:"2-digit", hour:"2-digit", minute:"2-digit" }) || "";
function Detalhe({ rotulo, valor, cor }) {
  return (
    <div style={{ background:"var(--pc-white-2, rgba(255,255,255,0.02))", border:"1px solid var(--pc-white-6, rgba(255,255,255,0.06))", borderRadius:8, padding:"7px 10px" }}>
      <div style={{ fontSize:9, color:"#64748b", fontWeight:700, letterSpacing:0.5, marginBottom:3, textTransform:"uppercase" }}>{rotulo}</div>
      <div style={{ fontSize:12, color:cor||C.text, fontWeight:600, wordBreak:"break-word" }}>{valor}</div>
    </div>
  );
}

// Carrossel de fotos dos produtos do pedido (igual aos cards de Produtos, com setinha p/ navegar)
function CarrosselProdutos({ itens }) {
  const [idx, setIdx] = useState(0);
  if (!itens || itens.length === 0) return null;
  const i = Math.min(idx, itens.length - 1);
  const atual = itens[i];
  const multiplos = itens.length > 1;
  const prev = (e) => { e.stopPropagation(); setIdx((i - 1 + itens.length) % itens.length); };
  const next = (e) => { e.stopPropagation(); setIdx((i + 1) % itens.length); };
  const seta = (lado) => ({
    position:"absolute", top:"50%", [lado]:6, transform:"translateY(-50%)",
    width:26, height:26, borderRadius:"50%", border:"none", background:"rgba(0,0,0,0.55)",
    color:"#fff", fontSize:18, fontWeight:900, cursor:"pointer", lineHeight:1, padding:0,
    display:"flex", alignItems:"center", justifyContent:"center",
  });
  return (
    <div style={{ position:"relative", width:150, flexShrink:0 }} title={atual.nome}>
      {atual.foto ? (
        <img src={atual.foto} alt={atual.nome} style={{ width:"100%", height:130, objectFit:"cover", borderRadius:8, display:"block" }} />
      ) : (
        <div style={{ width:"100%", height:130, borderRadius:8, background:C.panel, border:"1px solid "+C.border, display:"flex", alignItems:"center", justifyContent:"center", fontSize:38, opacity:0.5 }}>📦</div>
      )}
      {multiplos && (
        <>
          <button onClick={prev} style={seta("left")}>‹</button>
          <button onClick={next} style={seta("right")}>›</button>
          <div style={{ position:"absolute", bottom:6, left:"50%", transform:"translateX(-50%)", background:"rgba(0,0,0,0.65)", color:"#fff", fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:10 }}>{i+1}/{itens.length}</div>
        </>
      )}
    </div>
  );
}

// Itens de um pedido com foto resolvida do catálogo (usado no resumo e no popup de detalhes)
function itensComFoto(p, produtos) {
  return (p.itens || []).length > 0
    ? p.itens.map(it => ({ ...it, foto: produtos.find(pr => pr.id === it.produto_id)?.fotoBase64 || null }))
    : [{ produto_id: p.produto_id, nome: p.produto, qtd: 1, valor_unit: parseFloat(p.valor) || 0, foto: produtos.find(pr => pr.id === p.produto_id)?.fotoBase64 || null }];
}

// Tile compacto de pedido (foto + nome + cliente + status), igual ao card de seleção de produto
function PedidoResumoTile({ pedido, produtos, onClick }) {
  const si = statusInfo(pedido.status);
  const foto = itensComFoto(pedido, produtos)[0]?.foto || null;
  return (
    <button onClick={onClick}
      style={{ position:"relative", background:C.card, border:"1px solid "+C.border, borderRadius:12, padding:10, cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", gap:6, textAlign:"center" }}>
      <span style={{ position:"absolute", top:6, right:6, width:20, height:20, borderRadius:"50%", background:C.accent2, color:"#04111f", fontSize:13, fontWeight:900, display:"flex", alignItems:"center", justifyContent:"center", lineHeight:1 }}>+</span>
      {foto ? (
        <img src={foto} alt={pedido.produto} style={{ width:56, height:56, objectFit:"cover", borderRadius:8 }} />
      ) : (
        <div style={{ width:56, height:56, borderRadius:8, background:C.panel, display:"flex", alignItems:"center", justifyContent:"center", fontSize:26 }}>📦</div>
      )}
      <div style={{ fontSize:11, fontWeight:700, color:C.text, lineHeight:1.3, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"100%" }}>{pedido.produto}</div>
      <div style={{ fontSize:10, color:C.muted, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"100%" }}>👤 {pedido.cliente}</div>
      <span style={{ fontSize:10, fontWeight:700, color:si.cor, background:withAlpha(si.cor, "18"), border:"1px solid "+withAlpha(si.cor, "44"), borderRadius:8, padding:"2px 8px", whiteSpace:"nowrap" }}>{si.icone} {si.curto}</span>
    </button>
  );
}

// Tile que agrupa vários pedidos numa categoria só (compacto, não ocupa a
// grade com um card por pedido) — usado tanto pra "Outros" quanto pra
// "Prontos p/ entrega".
function PedidoGrupoTile({ icon, label, count, cor, onClick }) {
  return (
    <button onClick={onClick}
      style={{ background:C.card, border:"1px dashed "+(cor||C.border), borderRadius:12, padding:10, cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:6, textAlign:"center", minHeight:112 }}>
      <div style={{ width:56, height:56, borderRadius:8, background:(cor?withAlpha(cor, "18"):C.panel), display:"flex", alignItems:"center", justifyContent:"center", fontSize:26 }}>{icon}</div>
      <div style={{ fontSize:11, fontWeight:700, color:cor||C.text }}>{label}</div>
      <div style={{ fontSize:10, color:C.muted }}>{count} pedido{count===1?"":"s"}</div>
    </button>
  );
}

function FilamentoBuscaSelect({ atual, filamentos, corHex, onSelecionar }) {
  const [busca, setBusca] = useState("");
  const [aberto, setAberto] = useState(false);
  const norm = s => (s||"").toLowerCase();
  const filtrados = (filamentos||[]).filter(f => {
    if (!busca.trim()) return true;
    const q = norm(busca);
    return norm(f.cor).includes(q) || norm(f.nome).includes(q) || norm(f.marca).includes(q) || norm(f.material).includes(q);
  });
  return (
    <div style={{ position:"relative", flex:1, minWidth:150 }}>
      <span style={{ position:"absolute", left:9, top:"50%", transform:"translateY(-50%)", fontSize:11, pointerEvents:"none", color:C.muted }}>🔍</span>
      <div style={{ position:"absolute", left:27, top:"50%", transform:"translateY(-50%)", width:11, height:11, borderRadius:3, background:corHex(atual?.nome), border:"1px solid "+C.border, pointerEvents:"none" }} />
      <input
        value={aberto ? busca : (atual?.nome || "")}
        onChange={e=>setBusca(e.target.value)}
        onFocus={()=>{ setAberto(true); setBusca(""); }}
        onBlur={()=>setTimeout(()=>setAberto(false), 150)}
        placeholder="Buscar filamento..."
        style={{ width:"100%", boxSizing:"border-box", background:C.bg, border:"1px solid "+C.border, borderRadius:6, color:C.text, padding:"5px 8px 5px 44px", fontSize:12, outline:"none" }}
      />
      {aberto && (
        <div style={{ position:"absolute", top:"calc(100% + 4px)", left:0, right:0, zIndex:30, background:C.panel, border:"1px solid "+C.border, borderRadius:8, maxHeight:200, overflowY:"auto", boxShadow:"0 12px 28px rgba(0,0,0,0.45)" }}>
          {filtrados.length===0 && <div style={{ padding:"8px 10px", color:C.muted, fontSize:11 }}>Nenhum filamento encontrado</div>}
          {filtrados.map(f => (
            <div key={f.id} onMouseDown={e=>{ e.preventDefault(); onSelecionar(f); setBusca(""); setAberto(false); }}
              style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 10px", cursor:"pointer", borderBottom:"1px solid "+C.border }}>
              <div style={{ width:12, height:12, borderRadius:3, background:corHex(f.cor), border:"1px solid "+C.border, flexShrink:0 }} />
              <span style={{ color:C.text, fontSize:12, fontWeight:600, flex:1, minWidth:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{[f.marca, f.material, f.cor].filter(Boolean).join(" ")}</span>
              <span style={{ color:C.accent2, fontSize:11, fontWeight:700, flexShrink:0 }}>R${parseFloat(f.custo||0).toFixed(2)}/kg</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Popup com as informações completas de um pedido (aberto pelo "+" do resumo)
// Lista/edita os produtos de UM pedido: peso, horas e preço alteráveis só neste pedido (não no catálogo)
function EditorProdutosPedido({ pedido, produtos, impressoras, filamentos, corHex, onSalvar }) {
  const base = (pedido.itens || []).length > 0
    ? pedido.itens
    : (pedido.produto_id || pedido.produto)
      ? [{ produto_id: pedido.produto_id || null, nome: pedido.produto || "Produto", qtd: 1, valor_unit: parseFloat(pedido.valor) || 0, peso: pedido.peso ?? "", horas_impressao: pedido.horas_impressao ?? "" }]
      : [];
  const [itens, setItens] = useState(base.map(it => {
    const prod = produtos.find(pr => pr.id === it.produto_id);
    // Peso original = soma do peso dos filamentos do produto (filamento e peso são a mesma coisa)
    const pesoOrig = (prod?.filamentos_usados || []).reduce((s,f)=>s+(parseFloat(f.peso)||0),0);
    const temPeso = it.peso !== "" && it.peso != null;
    const temHoras = it.horas_impressao !== "" && it.horas_impressao != null;
    return {
      ...it,
      qtd: it.qtd ?? 1,
      valor_unit: it.valor_unit ?? (parseFloat(prod?.preco) || 0),
      peso: temPeso ? it.peso : (pesoOrig || ""),
      horas_impressao: temHoras ? it.horas_impressao : arredondarHoras(prod?.horas_impressao ?? ""),
      impressora_id: it.impressora_id ?? prod?.impressora_id ?? null,
      filamentos_usados: (it.filamentos_usados && it.filamentos_usados.length) ? it.filamentos_usados : (prod?.filamentos_usados || []),
      obs: it.obs || "",
    };
  }));
  const [salvando, setSalvando] = useState(false);
  const [expandido, setExpandido] = useState(null);
  if (itens.length === 0) return null;
  const set = (i, campo, val) => setItens(arr => arr.map((it, idx) => idx === i ? { ...it, [campo]: val } : it));
  // Troca a cor/filamento usado num item e reajusta o preço proporcionalmente à variação de custo
  const trocarFilamento = (i, fi, novoFilId) => {
    const novoFil = (filamentos || []).find(f => f.id === novoFilId);
    if (!novoFil) return;
    setItens(arr => arr.map((it, idx) => {
      if (idx !== i) return it;
      const antigos = it.filamentos_usados || [];
      const antigo = antigos[fi];
      if (!antigo) return it;
      const peso = parseFloat(antigo.peso) || 0;
      const custo_g = (parseFloat(novoFil.custo) || 0) / 1000;
      const custo_total = parseFloat((peso * custo_g).toFixed(2));
      const custoAntigoTotal = parseFloat(antigo.custo_total) || 0;
      const novosFil = antigos.map((f, idx2) => idx2 === fi
        ? { id: novoFil.id, nome: novoFil.cor || novoFil.nome, material: novoFil.material, custo_g, peso, custo_total }
        : f);
      const custoUnitAtual = it.custo_unit != null ? parseFloat(it.custo_unit) : null;
      const valorAtual = parseFloat(it.valor_unit) || 0;
      let novoCustoUnit = it.custo_unit ?? null;
      let novoValorUnit = valorAtual;
      if (custoUnitAtual != null && custoUnitAtual > 0) {
        const ratio = valorAtual / custoUnitAtual; // mantém a margem já aplicada neste item
        novoCustoUnit = parseFloat((custoUnitAtual - custoAntigoTotal + custo_total).toFixed(2));
        novoValorUnit = parseFloat((novoCustoUnit * ratio).toFixed(2));
      } else {
        novoValorUnit = parseFloat((valorAtual - custoAntigoTotal + custo_total).toFixed(2));
      }
      toast(`🎨 Cor trocada para ${novoFil.cor || novoFil.nome} — preço ajustado para R$ ${novoValorUnit.toFixed(2)}`, "success");
      return { ...it, filamentos_usados: novosFil, custo_unit: novoCustoUnit, valor_unit: novoValorUnit };
    }));
  };
  // Troca a impressora usada NESTE item do pedido (não mexe no catálogo) e
  // reajusta o preço pela variação de energia+desgaste, preservando a margem
  // já aplicada — mesma lógica de trocarFilamento.
  const trocarImpressora = (i, novoImpId) => {
    const novaImp = (impressoras || []).find(im => im.id === novoImpId);
    if (!novaImp) return;
    setItens(arr => arr.map((it, idx) => {
      if (idx !== i) return it;
      const antigaImp = (impressoras || []).find(im => im.id === it.impressora_id);
      const horas = parseFloat(it.horas_impressao) || 0;
      const custoAntigoEnDes = ((parseFloat(antigaImp?.consumo_hr)||0) + (parseFloat(antigaImp?.desgaste_hr)||0)) * horas;
      const custoNovoEnDes = ((parseFloat(novaImp.consumo_hr)||0) + (parseFloat(novaImp.desgaste_hr)||0)) * horas;
      const delta = custoNovoEnDes - custoAntigoEnDes;
      const custoUnitAtual = it.custo_unit != null ? parseFloat(it.custo_unit) : null;
      const valorAtual = parseFloat(it.valor_unit) || 0;
      let novoCustoUnit = it.custo_unit ?? null;
      let novoValorUnit = valorAtual;
      if (custoUnitAtual != null && custoUnitAtual > 0) {
        const ratio = valorAtual / custoUnitAtual; // mantém a margem já aplicada neste item
        novoCustoUnit = parseFloat((custoUnitAtual + delta).toFixed(2));
        novoValorUnit = parseFloat((novoCustoUnit * ratio).toFixed(2));
      } else {
        novoValorUnit = parseFloat((valorAtual + delta).toFixed(2));
      }
      toast(`🖨️ Impressora trocada para ${novaImp.nome} — preço ajustado para R$ ${novoValorUnit.toFixed(2)}`, "success");
      return { ...it, impressora_id: novaImp.id, impressora_nome: novaImp.nome, custo_unit: novoCustoUnit, valor_unit: novoValorUnit };
    }));
  };
  const total = itens.reduce((s, it) => s + (parseFloat(it.valor_unit) || 0) * (parseInt(it.qtd) || 1), 0);
  const salvar = async () => {
    setSalvando(true);
    const limpos = itens.map(it => ({
      ...it,
      qtd: parseInt(it.qtd) || 1,
      valor_unit: parseFloat(it.valor_unit) || 0,
      peso: it.peso === "" || it.peso == null ? null : parseFloat(it.peso) || 0,
      horas_impressao: it.horas_impressao === "" || it.horas_impressao == null ? null : parseFloat(it.horas_impressao) || 0,
    }));
    try { await onSalvar(limpos); } finally { setSalvando(false); }
  };
  const inputMini = { width:70, background:C.bg, border:"1px solid "+C.border, borderRadius:6, color:C.warning, padding:"4px 6px", fontSize:12, outline:"none", textAlign:"center" };
  const campoLbl = { display:"flex", flexDirection:"column", gap:2, fontSize:9, color:C.muted, fontWeight:700, alignItems:"center" };
  return (
    <div style={{ background:C.panel, border:"1px solid "+withAlpha(C.accent2, "33"), borderRadius:10, padding:12 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10, gap:8, flexWrap:"wrap" }}>
        <div style={{ color:C.accent2, fontSize:12, fontWeight:800, letterSpacing:0.5 }}>🧩 PRODUTOS DESTE PEDIDO</div>
        <Btn small color={C.success} onClick={salvar} disabled={salvando}>{salvando ? "⏳ Salvando..." : "💾 Salvar alterações"}</Btn>
      </div>
      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        {itens.map((it, i) => {
          const prod = produtos.find(pr => pr.id === it.produto_id);
          const imp = impressoras.find(im => im.id === (it.impressora_id ?? prod?.impressora_id));
          const aberto = expandido === i;
          return (
            <div key={it.produto_id || i} style={{ background:C.card, border:"1px solid "+C.border, borderRadius:8, padding:"8px 10px" }}>
              <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
                {prod?.fotoBase64
                  ? <img src={prod.fotoBase64} alt={it.nome} style={{ width:36, height:36, objectFit:"cover", borderRadius:6 }} />
                  : <div style={{ width:36, height:36, borderRadius:6, background:C.panel, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, opacity:0.5 }}>📦</div>}
                <span style={{ color:C.text, fontWeight:700, fontSize:13, flex:1, minWidth:120 }}>{it.nome}</span>
                <label style={campoLbl}>QTD<input type="number" min="1" value={it.qtd} onChange={e=>set(i,"qtd",e.target.value)} style={inputMini} /></label>
                <label style={campoLbl}>PESO(g)<input type="number" value={it.peso} onChange={e=>set(i,"peso",e.target.value)} placeholder="—" style={inputMini} /></label>
                <label style={campoLbl}>HRS<input type="number" value={it.horas_impressao} onChange={e=>set(i,"horas_impressao",e.target.value)} placeholder="—" style={inputMini} /></label>
                <label style={campoLbl}>PREÇO R$<input type="number" value={it.valor_unit} onChange={e=>set(i,"valor_unit",e.target.value)} style={{...inputMini, color:C.success}} /></label>
                <button onClick={()=>setExpandido(aberto?null:i)} style={{ background:"none", border:"1px solid "+C.border, borderRadius:6, color:C.muted, cursor:"pointer", fontSize:11, padding:"4px 8px", whiteSpace:"nowrap" }}>{aberto?"▲ Menos":"ℹ️ Ver tudo"}</button>
              </div>

              {/* Filamentos usados neste item — trocar a cor recalcula o preço automaticamente */}
              {(it.filamentos_usados||[]).length > 0 && (
                <div style={{ marginTop:8, paddingTop:8, borderTop:"1px dashed "+C.border, display:"flex", flexDirection:"column", gap:6 }}>
                  <div style={{ fontSize:9, color:C.muted, fontWeight:700, letterSpacing:0.5, textTransform:"uppercase" }}>🧵 Filamentos usados</div>
                  {it.filamentos_usados.map((f, fi) => (
                    <div key={fi} style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                      <FilamentoBuscaSelect atual={f} filamentos={filamentos} corHex={corHex} onSelecionar={novoFil=>trocarFilamento(i, fi, novoFil.id)} />
                      <span style={{ fontSize:11, color:C.muted, flexShrink:0 }}>{f.peso}g</span>
                      <span style={{ fontSize:11, color:C.success, fontWeight:700, flexShrink:0 }}>R$ {(parseFloat(f.custo_total)||0).toFixed(2)}</span>
                    </div>
                  ))}
                </div>
              )}

              {/* Observações deste item */}
              <div style={{ marginTop:8 }}>
                <input value={it.obs||""} onChange={e=>set(i,"obs",e.target.value)} placeholder="📝 Observações deste item (opcional)"
                  style={{ width:"100%", boxSizing:"border-box", background:C.bg, border:"1px solid "+C.border, borderRadius:6, color:C.text, padding:"6px 10px", fontSize:12, outline:"none" }} />
              </div>

              {aberto && (
                <div style={{ marginTop:8, paddingTop:8, borderTop:"1px dashed "+C.border, display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))", gap:6, fontSize:11, color:C.muted }}>
                  <div>💲 Subtotal: <strong style={{ color:C.success }}>R$ {((parseFloat(it.valor_unit)||0)*(parseInt(it.qtd)||1)).toFixed(2)}</strong></div>
                  {prod ? (
                    <>
                      <div style={{ display:"flex", alignItems:"center", gap:5 }}>
                        🖨️ {impressoras.length > 0 ? (
                          <select value="" onChange={e=>e.target.value && trocarImpressora(i, e.target.value)} title="Trocar impressora só deste item — recalcula o preço"
                            style={{ background:C.bg, border:"1px solid "+C.border, borderRadius:5, color:C.text, fontSize:11, padding:"2px 4px", outline:"none" }}>
                            <option value="">{imp?.nome || prod.impressora_nome || "Selecionar"}</option>
                            {impressoras.filter(im2=>im2.id!==(it.impressora_id??prod?.impressora_id)).map(im2=><option key={im2.id} value={im2.id}>{im2.nome}</option>)}
                          </select>
                        ) : (imp?.nome || prod.impressora_nome || "—")}
                      </div>
                      <div>⏱️ Padrão: {prod.horas_impressao ? arredondarHoras(prod.horas_impressao)+"h" : "—"}</div>
                      <div>📦 Estoque: {prod.estoque ?? "—"}</div>
                      <div>💰 Preço catálogo: {prod.preco ? "R$ "+parseFloat(prod.preco).toFixed(2) : "—"}</div>
                      <div>🧾 Custo: {prod.custo_total ? "R$ "+parseFloat(prod.custo_total).toFixed(2) : "—"}</div>
                      {(prod.filamentos_usados||[]).length>0 && <div style={{ gridColumn:"1/-1" }}>🧵 {prod.filamentos_usados.map(f=>`${f.nome||f.cor} ${f.peso}g`).join(" + ")}</div>}
                      {(prod.materiais_usados||[]).length>0 && <div style={{ gridColumn:"1/-1" }}>🔧 {prod.materiais_usados.map(m=>`${m.qtd} ${m.unidade} ${m.nome}`).join(", ")}</div>}
                    </>
                  ) : (
                    <div style={{ gridColumn:"1/-1", opacity:0.7 }}>Produto não está mais no catálogo — dados apenas deste pedido.</div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div style={{ marginTop:8, textAlign:"right", fontSize:12, color:C.muted }}>
        Total: <strong style={{ color:C.success, fontSize:14 }}>R$ {total.toFixed(2)}</strong>
      </div>
    </div>
  );
}

export function Pedidos({ coresCustom, notificacaoDestino }) {
  const empty = { previsao_entrega:"", cliente:"", cliente_id:"", cliente_celular:"", cliente_wa:false, produto:"", produto_id:"", filamento_id:"", filamento_nome:"", impressora_id:"", impressora_nome:"", horas_impressao:"", mao_obra_hrs:"", mao_obra_valor_hr:"", peso:"", status:"aguardando_impressao", valor:"", obs:"", filamentos_usados:[], materiais_usados:[], itens:[], venda:VENDA_VAZIA };
  const [data, setData] = useState([]); const [filamentos, setFilamentos] = useState([]); const [impressoras, setImpressoras] = useState([]); const [produtos, setProdutos] = useState([]); const [clientes, setClientes] = useState([]);
  const [form, setForm] = useState(empty); const [editId, setEditId] = useState(null);
  const [precoBaseTaxas, setPrecoBaseTaxas] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [formAberto, setFormAberto] = useState(false);
  const [salvandoPedido, setSalvandoPedido] = useState(false);
  const salvandoPedidoRef = useRef(false);
  const pedidoEditadoRef = useRef(null);
  const [conflitoPedido, setConflitoPedido] = useState(null);
  const [busyId, setBusyId] = useState(null);
  const busyRef = useRef(false);
  const [modalSelecionarProduto, setModalSelecionarProduto] = useState(false);
  const [resumoDetalhe, setResumoDetalhe] = useState(null);
  const [modalProntosPedidos, setModalProntosPedidos] = useState(false);
  const [modalOutrosPedidos, setModalOutrosPedidos] = useState(false);
  const [perdaPedido, setPerdaPedido] = useState(null);
  const [perdaForm, setPerdaForm] = useState({ motivo:"", peso:"", tempo:"", valor:"" });
  const [salvandoPerda, setSalvandoPerda] = useState(false);
  const [buscaProdutoForm, setBuscaProdutoForm] = useState("");
  const [modalNovoCliente, setModalNovoCliente] = useState(false); const [buscaCliente, setBuscaCliente] = useState("");
  const [formNovoCliente, setFormNovoCliente] = useState({nome:"",celular:"",instagram:""});
  // Layout do popup de seleção de produtos: lado a lado no desktop, empilhado
  // no mobile — com altura própria em cada bloco (em vez de flex-wrap) pra
  // garantir que cada lista role de verdade e o rodapé com os botões não
  // suma da tela junto com o scroll.
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 640);
  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  const [clienteSugestoesAberto, setClienteSugestoesAberto] = useState(false);
  const [salvandoCliente, setSalvandoCliente] = useState(false);
  const [waModal, setWaModal] = useState(null); const [waMensagem, setWaMensagem] = useState(""); const [waEnviando, setWaEnviando] = useState(false); const [waOk, setWaOk] = useState(false); const [waErro, setWaErro] = useState("");
  const [chatPedido, setChatPedido] = useState(null);
  const [confirmar, modalConfirm] = useConfirm();
  const [pagamentoCfg, setPagamentoCfg] = useState({});
  const [receberModal, setReceberModal] = useState(null);
  const [receberValor, setReceberValor] = useState("");
  const [receberMetodo, setReceberMetodo] = useState("dinheiro");
  const [receberQr, setReceberQr] = useState("");
  const [receberPix, setReceberPix] = useState("");
  const [receberCupom,setReceberCupom] = useState(null);
  const statusMP = useStatusMercadoPago(mpHabilitado() ? getUser()?.uid : null);
  // PagBank (Sandbox no desenvolvimento, produção no site) e InfinitePay (só desenvolvimento)
  const statusPB = useStatusProvedor(getUser()?.uid, "pagbank");
  const statusIP = useStatusProvedor(getUser()?.uid, "infinitepay");
  const [recebendo,setRecebendo] = useState(false);
  const recebendoRef=useRef(false);
  const [repasseModal, setRepasseModal] = useState(null);
  const tabelaLojas = useTaxasLojas();
  const canais = listaCanais(tabelaLojas.lojas);
  const maquininhas = listaMaquininhas(pagamentoCfg);
  const [materiais, setMateriais] = useState([]);
  const { config:voConfig, salvar:salvarVoConfig } = useVendaOnlineConfig(getUser()?.uid);
  const setVenda = (patch) => setForm(f => ({ ...f, venda: { ...(f.venda || VENDA_VAZIA), ...patch } }));
  // Trocar de canal zera a taxa da loja anterior e aplica o padrão salvo da
  // nova (custos, embalagem, cartão) — ver aplicarPadraoDoCanal.
  const mudarCanal = (canal) => setForm(f => {
    const r = aplicarPadraoDoCanal({ venda:f.venda, materiaisUsados:f.materiais_usados, canal, config:voConfig, materiais });
    return { ...f, venda:r.venda, materiais_usados:r.materiaisUsados };
  });
  const setEmbalagem = (itens) => setForm(f => ({ ...f, materiais_usados:[...(f.materiais_usados||[]).filter(m=>!m.envio), ...itens] }));
  // Custo criado no pedido já entra na lista salva pros próximos
  const criarCusto = async (dados) => {
    const c = novoCusto(dados);
    if (!c.nome || !(c.valor > 0)) { toast("Informe o nome e o valor do custo.", "warning"); return false; }
    setForm(f => ({ ...f, venda:{ ...f.venda, custos:[...(f.venda?.custos||[]), { id:c.id, nome:c.nome, tipo:c.tipo, valor:c.valor }] } }));
    try { await salvarVoConfig({ ...voConfig, custos:[...voConfig.custos, c] }); }
    catch (e) { console.error(e); toast("O custo entrou no pedido, mas não deu pra salvar na lista.", "warning"); }
    return true;
  };
  const salvarPadraoCanal = async () => {
    const canal = form.venda?.canal;
    const nome = canais.find(c=>c.id===canal)?.nome || canal;
    try {
      await salvarVoConfig({ ...voConfig, canais:{ ...voConfig.canais, [canal]:padraoDoPedido(form.venda, form.materiais_usados, voConfig) } });
      toast(`⭐ Padrão de ${nome} salvo — entra sozinho nos próximos pedidos.`, "success");
    } catch (e) { console.error(e); toast("Não foi possível salvar o padrão.", "error"); }
  };
  const selecionarCupomRecebimento = cupom => {
    try {
      const pedido=cupom ? descontarPedido(receberModal,cupom) : receberModal;
      setReceberCupom(cupom);
      setReceberValor(calcPagamento(pedido).saldo.toFixed(2));
    } catch(error) { toast(error.message,"warning"); }
  };
  const corHex = (nome) => { const c = [...CORES_PRESET,...coresCustom].find(c=>c.nome===nome); return c?.hex||"#888"; };
  const carregar = async () => {
    setLoading(true); setLoadError("");
    try {
      let [p,f,i,pr,cl,ma] = await Promise.all([
        fbList("pedidos"),
        fbList("filamentos").catch(()=>[]),
        fbList("impressoras").catch(()=>[]),
        fbList("produtos").catch(()=>[]),
        fbList("clientes").catch(()=>[]),
        fbList("materiais").catch(()=>[]),
      ]);
      try { p = await espelharPedidosSite(p, { produtos:pr, impressoras:i }); } catch (e) { toast("Os pedidos do site não foram sincronizados. Tente atualizar a página.", "warning"); }
      setData(p); setFilamentos(f); setImpressoras(i); setProdutos(pr); setClientes(cl); setMateriais(ma||[]);
      const maisUsada = i.find(imp=>imp.mais_usada);
      if (maisUsada) setForm(prev=>(!prev.impressora_id?{...prev,impressora_id:maisUsada.id,impressora_nome:maisUsada.nome}:prev));
    } catch (e) { setLoadError("Verifique sua conexão e tente novamente."); } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    carregar();
    const u = getUser();
    if (u?.uid) {
      getDoc(doc(db, "users", u.uid))
        .then(snap => { if (snap.exists()) setPagamentoCfg(snap.data().paymentConfig || {}); })
        .catch(() => {});
    }
    let encerrado = false, sincronizando = false, pendente = false;
    const sincronizarSite = async () => {
      if (sincronizando) { pendente = true; return; }
      sincronizando = true;
      try {
        do {
          pendente = false;
          const [lista, catalogo, maquinas] = await Promise.all([fbList("pedidos"), fbList("produtos"), fbList("impressoras")]);
          const atualizados = await espelharPedidosSite(lista, { produtos:catalogo, impressoras:maquinas });
          if (!encerrado) setData(atualizados);
        } while (pendente && !encerrado);
      } catch (e) { if (!encerrado) toast("Não foi possível atualizar os pedidos do site. Confira sua conexão.", "warning"); }
      finally { sincronizando = false; }
    };
    const unsubs = [
      ...(u?.uid ? [onSnapshot(collection(db, "users", u.uid, "pedidos_online"), sincronizarSite, () => {})] : []),
      fbWatch("pedidos", setData),
      fbWatch("filamentos", setFilamentos),
      fbWatch("produtos", setProdutos),
      fbWatch("clientes", setClientes),
      fbWatch("materiais", setMateriais),
    ];
    return () => { encerrado = true; unsubs.forEach(u => u && u()); };
  }, []);

  // Notificação "💰 Pagamento recebido": abre o pedido pago assim que a lista chega
  // (uma vez por notificação — atualizações da lista não reabrem)
  const destinoAberto = useRef(null);
  useEffect(() => {
    const id = notificacaoDestino?.tab === "pedidos" ? notificacaoDestino.pedidoId : null;
    if (!id || destinoAberto.current === notificacaoDestino.recebidoEm) return;
    const pedido = data.find(p => p.id === id);
    if (!pedido) return;
    destinoAberto.current = notificacaoDestino.recebidoEm;
    setResumoDetalhe(pedido);
  }, [notificacaoDestino, data]);

  // Abre o modal de recebimento com o saldo pré-preenchido
  const abrirReceber = (pedido) => {
    const { saldo } = calcPagamento(pedido);
    setReceberModal(pedido);
    setReceberCupom(null);
    setReceberValor(saldo > 0 ? saldo.toFixed(2) : "");
    setReceberMetodo("dinheiro");
    setReceberQr(""); setReceberPix("");
  };

  // Gera o Pix copia-e-cola + QR sempre que método/valor mudarem
  useEffect(() => {
    if (!receberModal || receberMetodo !== "pix") { setReceberQr(""); setReceberPix(""); return; }
    if (!pagamentoCfg.pixChave) { setReceberQr(""); setReceberPix(""); return; }
    if (!(Number(receberValor) > 0)) { setReceberQr(""); setReceberPix(""); return; }
    let atual=true;
    setReceberQr("");
    const u = getUser();
    const payload = gerarPixPayload({
      chave: pagamentoCfg.pixChave,
      nome: pagamentoCfg.pixBeneficiario || u?.empresa || u?.nome,
      cidade: pagamentoCfg.pixCidade || pagamentoCfg.endCidade,
      valor: parseFloat(receberValor) || 0,
      txid: receberModal.id ? `PED${String(receberModal.id).slice(-8)}` : "***",
    });
    setReceberPix(payload);
    QRCode.toDataURL(payload, { width: 240, margin: 1 }).then(url=>{if(atual)setReceberQr(url);}).catch(() => {if(atual)setReceberQr("");});
    return ()=>{atual=false;};
  }, [receberModal, receberMetodo, receberValor, pagamentoCfg]);

  const copiarPix = async () => {
    try { await navigator.clipboard.writeText(receberPix); toast("📋 Pix copiado!", "success"); }
    catch { toast("Não foi possível copiar", "error"); }
  };

  const confirmarRecebimento = async () => {
    if(recebendoRef.current) return;
    const valor = parseFloat(receberValor) || 0;
    if (valor <= 0 && !receberCupom) { toast("Informe um valor válido.", "warning"); return; }
    const metodoLabel = receberMetodo === "pix" ? "Pix" : receberMetodo === "maquininha" ? "Cartão (maquininha)" : "Dinheiro";
    recebendoRef.current=true;setRecebendo(true);
    try {
      if(receberCupom) {
        await registrarRecebimentoComCupom(receberModal,receberCupom,valor,metodoLabel);
        toast("Cupom e recebimento registrados no pedido.","success");
      } else if (!await registrarPagamento(receberModal, valor, metodoLabel)) return;
      setReceberModal(null); setReceberCupom(null); setReceberQr(""); setReceberPix("");
    } catch(error) { toast(error?.code ? "Não foi possível registrar o recebimento. Tente novamente." : error.message,"error"); }
    finally {recebendoRef.current=false;setRecebendo(false);}
  };
  const executarPedido = async (pedido, acao) => {
    if (busyRef.current) return false;
    busyRef.current = true; setBusyId(pedido.id);
    try { await acao(); return true; }
    catch (e) { toast(e.message || "Não foi possível salvar. Tente novamente.", "error"); return false; }
    finally { busyRef.current = false; setBusyId(null); }
  };
  const mudarStatus = (pedido, novoStatus) => executarPedido(pedido, async () => {
    const resultado = await mudarStatusPedido(pedido, novoStatus);
    resultado.avisos?.forEach(aviso => toast(aviso, "warning"));
    if (resultado.alterado) {
      toast("Etapa do pedido atualizada.", "success");
      if (novoStatus === "concluido" && pedido.cliente_email) {
        const u = getUser();
        Promise.resolve(emailPedidoConcluido(pedido.cliente, pedido.cliente_email, u?.empresa || u?.nome || "", pedido.produto)).catch(() => {});
      }
    }
  });
  const registrarPagamento = (pedido, valor, metodo = "manual") => executarPedido(pedido, async () => {
    const r = await registrarPagamentoPedido(pedido, valor, metodo);
    toast('Pagamento de R$ ' + r.valor.toFixed(2) + ' registrado.', "success");
  });
  const estornarPagamentos = async pedido => {
    if (!await confirmar("Estornar todos os pagamentos deste pedido e compensar os lançamentos no caixa?")) return;
    await executarPedido(pedido, () => estornarPagamentosPedido(pedido));
  };
  const confirmarRepasse = async (pedido, valor, lancarCustos = false) => {
    if (recebendoRef.current) return;
    recebendoRef.current = true; setRecebendo(true);
    try {
      const ok = await executarPedido(pedido, async () => {
        const r = await confirmarRepassePedido(pedido, valor, lancarCustos);
        if (!r) throw new Error("Este pedido já está quitado.");
        toast('Repasse de R$ ' + r.entradaCaixa.toFixed(2) + ' registrado.', "success");
      });
      if (ok) setRepasseModal(null);
    } finally { recebendoRef.current = false; setRecebendo(false); }
  };
  const vendaAoAlterarProdutos = venda => venda?.taxa_manual || venda?.repasse_em ? venda : { ...venda, taxa_plataforma:"", taxa_ref:null };
  const mudarPrecoProdutos = valor => { setPrecoBaseTaxas(null); setForm(f=>({...f,valor,venda:vendaAoAlterarProdutos(f.venda)})); };
  const aplicarPrecoTaxas = (valor, base) => {
    if (salvandoPedidoRef.current) return;
    setPrecoBaseTaxas(base);
    setForm(f=>({...f,valor:valor.toFixed(2),venda:vendaAoAlterarProdutos(f.venda)}));
  };
  const calcTotalItens = (itens) => itens.reduce((s,i)=>s+(parseFloat(i.valor_unit)||0)*(parseInt(i.qtd)||1),0);
  const adicionarItem = (prod) => {
    if (!prod) return;
    const custo_unit = custoUnitarioProduto(prod, impressoras);
    const existe = form.itens.find(i=>i.produto_id===prod.id);
    const novosItens = existe
      ? form.itens.map(i=>i.produto_id===prod.id?{...i,qtd:i.qtd+1}:i)
      : [...form.itens,{produto_id:prod.id,nome:prod.nome,qtd:1,valor_unit:parseFloat(prod.preco)||0,custo_unit,horas_impressao:arredondarHoras(prod.horas_impressao??""),impressora_id:prod.impressora_id||null,filamentos_usados:prod.filamentos_usados||[],materiais_usados:prod.materiais_usados||[]}];
    setPrecoBaseTaxas(null);
    setForm(v=>({...v,itens:novosItens,venda:vendaAoAlterarProdutos(v.venda),valor:calcTotalItens(novosItens).toFixed(2)}));
  };
  const removerItem = (pid) => {
    const novosItens = form.itens.filter(i=>i.produto_id!==pid);
    setPrecoBaseTaxas(null);
    setForm(v=>({...v,itens:novosItens,venda:vendaAoAlterarProdutos(v.venda),valor:calcTotalItens(novosItens).toFixed(2)||""}));
  };
  const ajustarQtdItem = (pid, novaQtd) => {
    const novosItens = form.itens.map(i=>i.produto_id===pid?{...i,qtd:parseInt(novaQtd)||1}:i);
    setPrecoBaseTaxas(null);
    setForm(v=>({...v,itens:novosItens,venda:vendaAoAlterarProdutos(v.venda),valor:calcTotalItens(novosItens).toFixed(2)}));
  };

  const valorItensCalc = (form.itens||[]).reduce((s,it)=>s+(parseFloat(it.valor_unit)||0)*(parseFloat(it.qtd)||1),0);
  // Preço/custo/lucro do pedido em formação — mostrado no popup de seleção
  // de produtos, já refletindo o "valor cobrado" quando o usuário sobrescreve.
  const precoVendaCalc = form.valor === "" || form.valor == null ? valorItensCalc : Number(form.valor) || 0;
  const custoCalc = calcCustoPedido(form, impressoras, produtos).total;
  // Venda online: preço dos produtos + frete cobrado − taxas − frete pago (null no balcão)
  const vendaCalc = calcularVendaOnline({ venda:form.venda, precoProdutos:precoVendaCalc, itens:form.itens, lojas:tabelaLojas.lojas, maquininhas });
  const comparacaoTaxas = !editId && vendaCalc ? compararPrecoComTaxas({ venda:form.venda, precoBase:precoBaseTaxas ?? precoVendaCalc, itens:form.itens, lojas:tabelaLojas.lojas, maquininhas }) : null;
  const canalForm = canais.find(c => c.id === form.venda?.canal) || null;
  const embalagemForm = embalagemDoPedido(form.materiais_usados);
  // custoCalc já inclui a embalagem (materiais_usados); `sobra` = o que a loja
  // deposita menos o que o vendedor paga à parte (frete, custos adicionais)
  const lucroCalc = (vendaCalc ? vendaCalc.sobra : precoVendaCalc) - custoCalc;

  // Aplica consumo de estoque do pedido. fator -1 = dá baixa, +1 = devolve.
  // Agrega por item antes de gravar para não haver condição de corrida no mesmo doc.
  const save = async () => {
    if (salvandoPedidoRef.current) return false;
    const temProduto = form.produto.trim() || (form.itens||[]).length > 0;
    if (!form.cliente.trim() || !temProduto) { toast("Preencha cliente e ao menos um produto!", "warning"); return false; }
    const nomePrincipal = form.produto.trim() || ((form.itens||[])[0]?.nome || "Pedido");
    const valorItens = (form.itens||[]).reduce((s,it)=>s+(parseFloat(it.valor_unit)||0)*(parseInt(it.qtd)||1),0);
    const valorFinal = form.valor === "" || form.valor == null ? valorItens : Number(form.valor);
    if (!Number.isFinite(valorFinal) || valorFinal < 0) { toast("Informe um valor válido para o pedido.", "warning"); return false; }
    const erros = validarVendaOnline(form.venda, vendaCalc);
    if (erros.length) { toast(erros[0], "warning"); return false; }
    salvandoPedidoRef.current = true; setSalvandoPedido(true);
    try {
    const imp = impressoras.find(i=>i.id===form.impressora_id);
    const payload = {
      cliente: form.cliente.trim(),
      cliente_id: form.cliente_id||null,
      cliente_celular: form.cliente_celular||null,
      cliente_wa: !!form.cliente_wa,
      produto: nomePrincipal,
      produto_id: form.produto_id||null,
      filamento_id: form.filamento_id||null,
      filamento_nome: form.filamento_nome||null,
      filamentos_usados: form.filamentos_usados||[],
      impressora_id: form.impressora_id||null,
      impressora_nome: imp?.nome||form.impressora_nome||null,
      horas_impressao: parseFloat(form.horas_impressao)||null,
      mao_obra_hrs: parseFloat(form.mao_obra_hrs)||null,
      mao_obra_valor_hr: parseFloat(form.mao_obra_valor_hr)||null,
      peso: parseFloat(form.peso)||null,
      status: form.status,
      // Venda online: valor = bruto (produtos + frete cobrado do cliente); as
      // taxas e o frete pago ficam em venda_online.custo_venda.
      valor: vendaCalc ? vendaCalc.bruto : valorFinal,
      venda_online: vendaOnlineParaSalvar(form.venda, vendaCalc, {
        canalNome: canalForm?.nome, origemTabela: tabelaLojas.origem, conferidaEm: tabelaLojas.atualizadoEm,
      }),
      obs: form.obs||null,
      materiais_usados: form.materiais_usados||[],
      itens: form.itens||[],
      previsao_entrega: form.previsao_entrega || null,
    };
    if (editId) {
      const anterior = pedidoEditadoRef.current;
      if (!anterior) throw new Error("Reabra o pedido antes de editar.");
      const mesmaVenda = JSON.stringify(form.venda) === JSON.stringify(vendaParaForm(anterior.venda_online, anterior.origem));
      if (mesmaVenda) Object.assign(payload, recalcularVendaOnlinePedido(anterior, payload.itens, valorFinal, { lojas:tabelaLojas.lojas, maquininhas, origemTabela:tabelaLojas.origem, conferidaEm:tabelaLojas.atualizadoEm }));
      await salvarAlteracoesPedido(anterior, payload);
    } else {
      await fbAdd("pedidos", { ...payload, status:"aguardando_impressao", pagamentos:[], estoque_baixado:false, data:new Date().toLocaleDateString("pt-BR") });
    }
    if (payload.cliente_id) fbUpdate("clientes", payload.cliente_id, { ultimoPedido:new Date().toISOString() }).catch(() => {});
    setPrecoBaseTaxas(null); setForm(empty); setEditId(null); pedidoEditadoRef.current = null; setFormAberto(false);
    toast(editId ? "Pedido atualizado." : "Pedido criado.", "success");
    return true;
    } catch (e) {
      if (e.code === "pedido/desatualizado") setConflitoPedido(e.pedidoAtual);
      toast(e.message || "Não foi possível salvar o pedido.", "error"); return false;
    }
    finally { salvandoPedidoRef.current = false; setSalvandoPedido(false); }
  };
  const edit = (p) => {
    setConflitoPedido(null);
    setPrecoBaseTaxas(null);
    const itens = p.itens || [];
    pedidoEditadoRef.current = p;
    // venda_online fica fora do form (o custo de venda dele não pode somar de
    // novo na prévia); o formulário trabalha com `venda` e o preço sem frete.
    const { venda_online, ...resto } = p;
    const valor = venda_online?.canal ? String(venda_online.preco_produtos ?? p.valor ?? "") : p.valor;
    setForm({...empty,...resto,valor,venda:vendaParaForm(venda_online, p.origem),filamentos_usados:p.filamentos_usados||[],materiais_usados:p.materiais_usados||[],itens,horas_impressao:p.horas_impressao||"",mao_obra_hrs:p.mao_obra_hrs||"",mao_obra_valor_hr:p.mao_obra_valor_hr||""});
    setEditId(p.id); setFormAberto(true);
    setTimeout(() => document.querySelector('[data-tour="pedidos-form"]')?.scrollIntoView?.({ behavior: "smooth", block: "start" }), 0);
  };
  const del = async id => {
    const p = data.find(x=>x.id===id);
    if (p && !podeExcluirPedido(p)) { setResumoDetalhe(p); return; }
    if (!p || !await confirmar('Excluir o pedido "' + (p.produto || p.cliente) + '"? Esta ação não pode ser desfeita.')) return;
    await executarPedido(p, () => excluirPedidoRascunho(p));
  };
  const cancelarPedido = async p => {
    if (!await confirmar('Cancelar o pedido "' + (p.produto || p.cliente) + '"? O histórico será mantido. Recebimentos devem ser estornados separadamente.')) return;
    await mudarStatus(p, "cancelado");
  };
  const registrarPerda = async () => {
    if (!perdaPedido || salvandoPerda) return;
    const valores = [perdaForm.peso, perdaForm.tempo, perdaForm.valor].map(v=>Number(v || 0));
    if (valores.some(v=>!Number.isFinite(v) || v<0)) { toast("Informe valores válidos para a perda.", "warning"); return; }
    setSalvandoPerda(true);
    try {
      const ok = await executarPedido(perdaPedido, () => registrarPerdaPedido(perdaPedido, {
        motivo:perdaForm.motivo || "Outro", filamento_perdido_g:valores[0], tempo_perdido_h:valores[1], valor_perdido:valores[2],
      }));
      if (ok) {
        toast("Perda registrada. O pedido voltou à fila para uma nova impressão.", "success");
        setPerdaPedido(null); setPerdaForm({motivo:"",peso:"",tempo:"",valor:""});
      }
    } finally { setSalvandoPerda(false); }
  };
  const salvarItensPedido = (pedido, novosItens) => executarPedido(pedido, async () => {
    const valor = novosItens.reduce((s,it)=>s+(Number(it.valor_unit)||0)*(Number(it.qtd)||1),0);
    const patch = recalcularVendaOnlinePedido(pedido, novosItens, valor, { lojas:tabelaLojas.lojas, maquininhas, origemTabela:tabelaLojas.origem, conferidaEm:tabelaLojas.atualizadoEm });
    await salvarAlteracoesPedido(pedido, patch);
    toast("Produtos e valores do pedido atualizados.", "success");
  });
  const vincularCliente = (c) => {
    setForm(f=>({...f, cliente:c.nome, cliente_id:c.id, cliente_celular:c.celular||"", cliente_wa:!!c.aceitaWhatsapp}));
    setModalNovoCliente(false); setBuscaCliente("");
  };

  const enviarWaMensagem = async () => {
    if (!waMensagem.trim()) return;
    setWaEnviando(true); setWaErro("");
    try {
      const numero = waModal.cliente_celular.replace(/\D/g, "");
      window.open(`https://wa.me/55${numero}?text=${encodeURIComponent(waMensagem)}`, "_blank");
      if (waModal.cliente_id) {
        await fbUpdate("clientes", waModal.cliente_id, { ultimoContato: new Date().toISOString() });
      }
      setWaOk(true);
      setTimeout(() => { setWaModal(null); setWaMensagem(""); setWaOk(false); }, 1500);
    } catch(e) { setWaErro(e.message || "Erro ao abrir WhatsApp"); }
    setWaEnviando(false);
  };

  const norm = s => (s||"").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g,"");
  const clientesFiltrados = clientes.filter(c => {
    if (!buscaCliente) return true;
    const b = norm(buscaCliente);
    return norm(c.nome).includes(b) || (c.celular||"").includes(buscaCliente) || norm(c.instagram||"").includes(b);
  });
  // Sugestões do campo "Cliente" do pedido — nome é só texto livre (opcional
  // vincular). Só sugere enquanto ainda não está vinculado a um cadastro.
  const sugestoesCliente = (!form.cliente_id && form.cliente.trim())
    ? clientes.filter(c => norm(c.nome).includes(norm(form.cliente))).slice(0, 6)
    : [];
  const selecionarClienteInline = (c) => {
    setForm(f => ({ ...f, cliente:c.nome, cliente_id:c.id, cliente_celular:c.celular||"", cliente_wa:!!c.aceitaWhatsapp }));
    setClienteSugestoesAberto(false);
  };
  const cadastrarCliente = async () => {
    if (!formNovoCliente.nome.trim()) { toast("Informe o nome do cliente!", "warning"); return; }
    setSalvandoCliente(true);
    try {
      const docRef = await fbAdd("clientes", {
        nome: formNovoCliente.nome.trim(),
        celular: formNovoCliente.celular.trim()||null,
        instagram: formNovoCliente.instagram.trim()||null,
        aceitaWhatsapp: !!formNovoCliente.celular.trim(),
      });
      setForm(f=>({...f, cliente:formNovoCliente.nome.trim(), cliente_id:docRef.id, cliente_celular:formNovoCliente.celular.trim()||"", cliente_wa:!!formNovoCliente.celular.trim()}));
      setModalNovoCliente(false); setFormNovoCliente({nome:"",celular:"",instagram:""});
      toast("✅ Cliente cadastrado e vinculado!", "success");
    } catch { toast("Erro ao cadastrar cliente", "error"); }
    finally { setSalvandoCliente(false); }
  };

  const STATUS_PRONTOS = ["concluido", "pronto_entrega"];
  const STATUS_DESTAQUE = ["conferindo_pagamento", "aguardando_impressao", "imprimindo"];
  const pedidosDestaque = data.filter(p => STATUS_DESTAQUE.includes(normalizarStatus(p.status)));
  const pedidosProntos  = data.filter(p => STATUS_PRONTOS.includes(normalizarStatus(p.status)));
  const pedidosOutros   = data.filter(p => ![...STATUS_DESTAQUE,...STATUS_PRONTOS].includes(normalizarStatus(p.status)));
  const pedidosAguardando = data.filter(p => normalizarStatus(p.status) === "aguardando_impressao").length;
  const pedidosImprimindo = data.filter(p => normalizarStatus(p.status) === "imprimindo").length;

  const formularioPedido = (
      <Card data-tour="pedidos-form">
        <h3 style={{ color:C.accent, margin:"0 0 14px", fontSize:15, letterSpacing:1 }}>{editId?"✏️ EDITAR PEDIDO":"➕ NOVO PEDIDO"}</h3>
        {editId && conflitoPedido && <div className="pw-edit-conflict" role="alert">
          <strong>Há uma versão mais recente deste pedido.</strong>
          <p>Seu rascunho continua aqui. Copie o que deseja manter; carregar a versão atual substitui os campos para você conferir e editar novamente.</p>
          <Btn outline onClick={() => edit(conflitoPedido)}>Carregar versão atual</Btn>
        </div>}
        <div style={{ marginBottom:14 }}>
          <div>
            <label style={{ color:C.muted, fontSize:10, fontWeight:700, letterSpacing:1.5, display:"block", marginBottom:6 }}>CLIENTE</label>
            <div style={{ position:"relative" }}>
              <input
                value={form.cliente}
                onChange={e => {
                  const v = e.target.value;
                  setForm(f => f.cliente_id
                    ? { ...f, cliente:v, cliente_id:"", cliente_celular:"", cliente_wa:false } // editar o nome desvincula
                    : { ...f, cliente:v });
                  setClienteSugestoesAberto(true);
                }}
                onFocus={() => setClienteSugestoesAberto(true)}
                onBlur={() => setTimeout(() => setClienteSugestoesAberto(false), 150)}
                aria-label="Cliente" placeholder="Nome do cliente"
                style={{
                  width:"100%", boxSizing:"border-box", background:C.card,
                  border:"1px solid "+(form.cliente_id ? "rgba(0,212,170,0.45)" : C.border),
                  borderRadius:10, color:C.text, padding: form.cliente ? "9px 30px 9px 12px" : "9px 12px",
                  fontSize:13, outline:"none",
                }}
              />
              {form.cliente_id && (
                <span title="Vinculado a um cadastro — telefone/WhatsApp disponíveis"
                  style={{ position:"absolute", right:10, top:"50%", transform:"translateY(-50%)", color:C.accent2, fontSize:13, pointerEvents:"none" }}>✓</span>
              )}
              {!form.cliente_id && form.cliente && (
                <button onClick={()=>setForm(f=>({...f,cliente:""}))} title="Limpar"
                  style={{ position:"absolute", right:8, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:14, lineHeight:1, padding:0 }}>✕</button>
              )}
              {clienteSugestoesAberto && sugestoesCliente.length > 0 && (
                <div style={{ position:"absolute", top:"calc(100% + 4px)", left:0, right:0, zIndex:30, background:C.panel, border:"1px solid "+C.border, borderRadius:8, maxHeight:180, overflowY:"auto", boxShadow:"0 12px 28px rgba(0,0,0,0.45)" }}>
                  {sugestoesCliente.map(c => (
                    <div key={c.id} onMouseDown={e=>{ e.preventDefault(); selecionarClienteInline(c); }}
                      style={{ padding:"8px 12px", cursor:"pointer", borderBottom:"1px solid "+C.border }}>
                      <div style={{ color:C.text, fontSize:12.5, fontWeight:600 }}>{c.nome}</div>
                      <div style={{ color:C.muted, fontSize:10.5, marginTop:1 }}>{c.celular ? `📱 ${c.celular}` : "sem telefone cadastrado"}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {form.cliente_celular ? (
              <div style={{ fontSize:11, color:"#25d366", marginTop:5 }}>📱 {form.cliente_celular}{form.cliente_wa ? " · WhatsApp" : ""}</div>
            ) : (
              <button onClick={()=>{ setFormNovoCliente(f=>({...f, nome:form.cliente||""})); setModalNovoCliente(true); }}
                style={{ background:"none", border:"none", color:C.accent2, cursor:"pointer", fontSize:11, fontWeight:700, padding:0, marginTop:5 }}>
                🔗 Vincular cadastro completo (telefone, WhatsApp...)
              </button>
            )}
          </div>
        </div>
        <div style={{ marginBottom:14 }}>
          <div style={{ color:C.muted, fontSize:10, fontWeight:700, letterSpacing:1.5, marginBottom:6 }}>ONDE VENDEU?</div>
          <SeletorCanal canais={canais} valor={form.venda?.canal || VENDA_VAZIA.canal} onChange={mudarCanal} />
        </div>
          <div style={{ padding:12, background:C.panel, borderRadius:10, border:"1px solid "+withAlpha(C.accent2, "44") }}>
            <div style={{ color:C.accent2, fontSize:12, fontWeight:700, marginBottom:10 }}>📦 PRODUTOS DO PEDIDO</div>
            {/* Sem `disabled` de propósito: um <button disabled> nem chega a
                disparar o onClick, então o aviso abaixo nunca aparecia — só
                parecia travado, sem feedback nenhum. O visual "desabilitado"
                continua (cores apagadas), mas o clique sempre funciona. */}
            <button onClick={()=>{ if (!form.cliente.trim()) { toast("Informe o nome do cliente antes de selecionar produtos.", "warning"); return; } setModalSelecionarProduto(true); }}
              style={{ width:"100%", background: form.cliente.trim() ? "linear-gradient(135deg,rgba(0,212,170,0.1),rgba(0,212,170,0.05))" : C.panel, border:"1px solid "+(form.cliente.trim() ? "rgba(0,212,170,0.4)" : C.border), borderRadius:10, color: form.cliente.trim() ? C.accent2 : C.muted, padding:"10px 14px", cursor:"pointer", opacity: form.cliente.trim() ? 1 : 0.6, fontSize:13, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center", gap:8 }}>
              <span style={{ fontSize:16, lineHeight:1 }}>+</span>
              <span>{form.itens.length>0 ? "Editar seleção de produtos" : "Selecionar produto"}</span>
            </button>
            {form.itens.length>0 && (
              <div onClick={()=>setModalSelecionarProduto(true)}
                style={{ marginTop:10, display:"flex", justifyContent:"space-between", alignItems:"center", background:C.card, border:"1px solid "+C.border, borderRadius:8, padding:"8px 12px", cursor:"pointer" }}>
                <span style={{ color:C.muted, fontSize:11.5 }}>{form.itens.length} produto{form.itens.length>1?"s":""} selecionado{form.itens.length>1?"s":""}</span>
                <span style={{ color:C.success, fontWeight:800, fontSize:13 }}>R$ {valorItensCalc.toFixed(2)}</span>
              </div>
            )}
          </div>
        {vendaCalc && (
          <div style={{ marginTop:14, display:"flex", flexDirection:"column", gap:10 }}>
            <VendaOnlineSecao venda={form.venda} onChange={setVenda} calc={vendaCalc} canal={canalForm} maquininhas={maquininhas} tabela={tabelaLojas}
              comparacaoTaxas={comparacaoTaxas} onAplicarPreco={!editId ? aplicarPrecoTaxas : undefined}
              catalogo={voConfig.custos} onCriarCusto={criarCusto}
              materiais={materiais} embalagem={embalagemForm} onEmbalagem={setEmbalagem}
              custoProducao={Math.max(0, custoCalc - embalagemForm.total)}
              onSalvarPadrao={salvarPadraoCanal} temPadrao={temPadrao(voConfig, form.venda?.canal)} />
          </div>
        )}
        <div className="pw-form-grid">
          <Inp aria-label="Preço dos produtos" label="PREÇO DOS PRODUTOS (R$)" type="number" min="0" step="0.01" value={form.valor} onChange={e=>mudarPrecoProdutos(e.target.value)} placeholder={valorItensCalc.toFixed(2)} />
          <Inp aria-label="Previsão de entrega" label="PREVISÃO DE ENTREGA" type="date" value={form.previsao_entrega || ""} onChange={e=>setForm(f=>({...f,previsao_entrega:e.target.value}))} />
        </div>
        <div style={{ marginTop:14 }}><Inp aria-label="Observações do pedido" label="OBSERVAÇÕES" value={form.obs || ""} onChange={e=>setForm(f=>({...f,obs:e.target.value}))} placeholder="Personalização, entrega ou orientação de produção" /></div>
        <div className="pw-form-summary"><span>Total do pedido<strong>R$ {(vendaCalc?.bruto ?? precoVendaCalc).toFixed(2)}</strong></span><span>Custo de produção<strong>R$ {custoCalc.toFixed(2)}</strong></span><span>Lucro estimado<strong style={{color:lucroCalc < 0 ? C.danger : C.success}}>R$ {lucroCalc.toFixed(2)}</strong></span></div>
        <div className="pw-form-footer"><Btn outline disabled={salvandoPedido} onClick={()=>setFormAberto(false)}>Fechar formulário</Btn><Btn disabled={salvandoPedido} onClick={save}>{salvandoPedido ? "Salvando…" : editId ? "Salvar alterações" : "Salvar pedido"}</Btn></div>
      </Card>
  );

  return (
    <div className="orders-page">
      {modalConfirm}

      <header className="orders-intro">
        <div><span className="orders-eyebrow">VENDAS E PRODUÇÃO</span><h1>Pedidos</h1><p>Cadastre, acompanhe o pagamento e avance cada pedido pela produção.</p></div>
        <Btn data-tour="pedidos-novo" onClick={()=>{ if (editId) { setPrecoBaseTaxas(null); setForm(empty); setEditId(null); pedidoEditadoRef.current=null; } setFormAberto(true); setTimeout(()=>document.querySelector('[data-tour="pedidos-form"]')?.scrollIntoView?.({behavior:"smooth",block:"start"}),0); }}>+ Novo pedido</Btn>
      </header>
      <section className="orders-summary" aria-label="Resumo dos pedidos">
        <article><span>Total de pedidos</span><strong>{data.length}</strong><small>em todo o histórico</small></article>
        <article><span>Aguardando impressão</span><strong>{pedidosAguardando}</strong><small>próximos da fila</small></article>
        <article className="is-printing"><span>Em impressão</span><strong>{pedidosImprimindo}</strong><small>em produção agora</small></article>
        <article className="is-ready"><span>Prontos</span><strong>{pedidosProntos.length}</strong><small>aguardando entrega</small></article>
      </section>

      {formAberto && formularioPedido}

      {/* Todos os pedidos: aguardando/imprimindo sempre em destaque, resto agrupado numa categoria só */}
      <Card data-tour="pedidos-lista">
        <div style={{ fontSize:12, color:"#06b6d4", fontWeight:700, letterSpacing:1, marginBottom:14 }}>📋 PEDIDOS</div>
        {loadError ? (
          <div role="alert" style={{color:C.muted,textAlign:"center",padding:20}}><p>{loadError}</p><Btn outline onClick={carregar}>Tentar novamente</Btn></div>
        ) : loading ? (
          <div style={{ color:C.muted, textAlign:"center", padding:20 }}>⏳ Carregando...</div>
        ) : data.length === 0 ? (
          <div style={{ color:C.muted, fontSize:13, textAlign:"center", padding:"20px 0" }}>Nenhum pedido cadastrado ainda</div>
        ) : (
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))", gap:10 }}>
            {pedidosDestaque.map(p => (
              <PedidoResumoTile key={p.id} pedido={p} produtos={produtos} onClick={()=>setResumoDetalhe(p)} />
            ))}
            {pedidosProntos.length > 0 && (
              <PedidoGrupoTile icon="📦" label="Prontos p/ entrega" count={pedidosProntos.length} cor="#10b981" onClick={()=>setModalProntosPedidos(true)} />
            )}
            {pedidosOutros.length > 0 && (
              <PedidoGrupoTile icon="📋" label="Outros" count={pedidosOutros.length} onClick={()=>setModalOutrosPedidos(true)} />
            )}
          </div>
        )}
      </Card>



      {/* Modal: registrar perda/falha de impressão de um pedido */}
      {perdaPedido && (
        <>
          <div onClick={()=>setPerdaPedido(null)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:1000 }} />
          <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"min(420px,94vw)", background:C.panel, border:"1px solid "+withAlpha(C.danger, "55"), borderRadius:18, padding:20, zIndex:1001, boxShadow:"0 24px 64px rgba(0,0,0,0.7)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
              <div style={{ fontWeight:900, fontSize:14, color:C.danger, letterSpacing:1 }}>⚠️ ADICIONAR PERDA</div>
              <button onClick={()=>setPerdaPedido(null)} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>✕</button>
            </div>
            <div style={{ color:C.muted, fontSize:12, marginBottom:14 }}>{perdaPedido.produto}{perdaPedido.cliente?` · ${perdaPedido.cliente}`:""}</div><p style={{color:C.muted,fontSize:12,lineHeight:1.6}}>A tentativa será registrada como perdida e o pedido voltará à fila. O material consumido não será devolvido ao estoque.</p>
            <div style={{ marginBottom:10 }}>
              <Sel label="MOTIVO" value={perdaForm.motivo} onChange={e=>setPerdaForm(f=>({...f,motivo:e.target.value}))}>
                <option value="">Selecionar motivo...</option>
                {MOTIVOS_PERDA.map(m=><option key={m} value={m}>{m}</option>)}
              </Sel>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
              <Inp label="FILAMENTO PERDIDO (g)" type="number" value={perdaForm.peso} onChange={e=>setPerdaForm(f=>({...f,peso:e.target.value}))} placeholder="0" />
              <Inp label="TEMPO PERDIDO (h)" type="number" value={perdaForm.tempo} onChange={e=>setPerdaForm(f=>({...f,tempo:e.target.value}))} placeholder="0" />
            </div>
            <div style={{ marginBottom:14 }}>
              <Inp label="VALOR PERDIDO (R$)" type="number" value={perdaForm.valor} onChange={e=>setPerdaForm(f=>({...f,valor:e.target.value}))} placeholder="Custo estimado do desperdício" />
            </div>
            <div style={{ display:"flex", gap:8 }}>
              <Btn color={C.danger} onClick={registrarPerda} disabled={salvandoPerda} style={{ flex:1 }}>{salvandoPerda?"⏳...":"⚠️ Registrar perda"}</Btn>
              <Btn outline onClick={()=>setPerdaPedido(null)}>Cancelar</Btn>
            </div>
          </div>
        </>
      )}

      {/* Modal: selecionar produto do catálogo (grade com foto, igual ao PDV) */}
      {modalSelecionarProduto && (
        <>
          <div onClick={()=>{ setModalSelecionarProduto(false); setBuscaProdutoForm(""); }} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:1000 }} />
          <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"min(880px,95vw)", background:C.panel, border:"1px solid "+withAlpha(C.accent2, "44"), borderRadius:18, padding:20, zIndex:1001, boxShadow:"0 24px 64px rgba(0,0,0,0.7)", maxHeight:"88vh", overflow:"hidden", display:"flex", flexDirection:"column", gap:14 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexShrink:0 }}>
              <div style={{ fontWeight:900, fontSize:14, color:C.accent2, letterSpacing:1 }}>📦 SELECIONAR PRODUTO</div>
              <button onClick={()=>{ setModalSelecionarProduto(false); setBuscaProdutoForm(""); }} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>✕</button>
            </div>

            <div style={{ display:"flex", flexDirection: isMobile ? "column" : "row", gap:16, flex:1, minHeight:0, overflow:"hidden" }}>
              {/* Esquerda: busca + grade de produtos (rolável) — altura própria
                  no mobile, senão o painel de itens empurra ela pra fora da tela */}
              <div style={{ flex: isMobile ? "0 0 auto" : "2 1 320px", height: isMobile ? "34vh" : undefined, minWidth: isMobile ? undefined : 260, display:"flex", flexDirection:"column", gap:10, minHeight:0 }}>
                <div style={{ position:"relative", flexShrink:0 }}>
                  <span style={{ position:"absolute", left:11, top:"50%", transform:"translateY(-50%)", fontSize:13, pointerEvents:"none" }}>🔍</span>
                  <input
                    value={buscaProdutoForm}
                    onChange={e => setBuscaProdutoForm(e.target.value)}
                    placeholder="Pesquisar produto..."
                    autoFocus
                    style={{ width:"100%", boxSizing:"border-box", background:C.card, border:"1px solid "+C.border, borderRadius:10, color:C.text, padding:"10px 14px 10px 32px", fontSize:13, outline:"none" }}
                  />
                  {buscaProdutoForm && (
                    <button onClick={()=>setBuscaProdutoForm("")} style={{ position:"absolute", right:10, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:14, lineHeight:1, padding:0 }}>✕</button>
                  )}
                </div>
                <div style={{ overflowY:"auto", flex:1 }}>
                  {produtos.length === 0 ? (
                    <div style={{ color:C.muted, textAlign:"center", padding:32 }}>Nenhum produto cadastrado.</div>
                  ) : (
                    <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))", gap:10 }}>
                      {produtos.filter(p=>!buscaProdutoForm||p.nome?.toLowerCase().includes(buscaProdutoForm.toLowerCase())).map(prod => {
                        const noPedido = form.itens.find(i=>i.produto_id===prod.id);
                        return (
                          <button key={prod.id} onClick={()=>adicionarItem(prod)}
                            style={{
                              background: noPedido ? "rgba(0,212,170,0.08)" : C.card,
                              border: "1px solid "+(noPedido ? "rgba(0,212,170,0.4)" : C.border),
                              borderRadius:12, padding:10, cursor:"pointer",
                              display:"flex", flexDirection:"column", alignItems:"center", gap:6,
                              transition:"all .15s", textAlign:"center",
                            }}>
                            {prod.fotoBase64 ? (
                              <img src={prod.fotoBase64} alt={prod.nome} style={{ width:56, height:56, objectFit:"cover", borderRadius:8 }} />
                            ) : (
                              <div style={{ width:56, height:56, borderRadius:8, background:C.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:26 }}>📦</div>
                            )}
                            <div style={{ fontSize:11, fontWeight:700, color:C.text, lineHeight:1.3 }}>{prod.nome}</div>
                            {prod.preco != null && <div style={{ fontSize:12, color:C.accent2, fontWeight:800 }}>R$ {parseFloat(prod.preco).toFixed(2)}</div>}
                            <div style={{ fontSize:10, color:C.muted }}>Estoque: {prod.estoque || 0}</div>
                            {noPedido && (
                              <div style={{ background:"var(--pc-ui-00d4aa, #00d4aa)", color:"var(--pc-ui-04111f, #04111f)", borderRadius:6, fontSize:10, fontWeight:900, padding:"2px 8px" }}>
                                {noPedido.qtd} no pedido
                              </div>
                            )}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              {/* Direita: painel fixo com os itens já selecionados — some pra
                  cá conforme clica na grade, dá pra ajustar qtd ou remover,
                  e conclui o pedido sem precisar fechar o popup antes. */}
              <div style={{ flex: isMobile ? "1 1 auto" : "1 1 240px", minWidth: isMobile ? undefined : 220, maxWidth: isMobile ? undefined : 300, display:"flex", flexDirection:"column", background:C.card, border:"1px solid "+C.border, borderRadius:12, padding:14, gap:10, minHeight:0 }}>
                <div style={{ color:C.accent2, fontSize:11, fontWeight:800, letterSpacing:1, flexShrink:0 }}>🛒 ITENS DO PEDIDO</div>
                <div style={{ overflowY:"auto", flex:1, display:"flex", flexDirection:"column", gap:6, minHeight:0 }}>
                  {form.itens.length === 0 ? (
                    <div style={{ color:C.muted, fontSize:11.5, textAlign:"center", padding:"16px 4px" }}>Clique num produto ao lado pra adicionar aqui.</div>
                  ) : form.itens.map(it => (
                    <div key={it.produto_id} style={{ background:C.panel, border:"1px solid "+withAlpha(C.accent2, "33"), borderRadius:8, padding:"7px 9px", display:"flex", flexDirection:"column", gap:4 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:6 }}>
                        <span style={{ color:C.text, fontSize:12, fontWeight:700, flex:1, minWidth:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{it.nome}</span>
                        <button onClick={()=>removerItem(it.produto_id)} title="Remover" style={{ background:"none", border:"none", color:C.danger, cursor:"pointer", fontSize:13, padding:0, flexShrink:0 }}>✕</button>
                      </div>
                      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:6 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:4 }}>
                          <span style={{ color:C.muted, fontSize:10 }}>Qtd</span>
                          <input type="number" min="1" value={it.qtd} onChange={e=>ajustarQtdItem(it.produto_id,e.target.value)}
                            style={{ width:42, background:C.card, border:"1px solid "+C.border, borderRadius:6, color:C.warning, padding:"2px 4px", fontSize:11, outline:"none", textAlign:"center" }} />
                        </div>
                        <span style={{ color:C.success, fontWeight:700, fontSize:12 }}>R$ {(it.valor_unit*it.qtd).toFixed(2)}</span>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ flexShrink:0, display:"flex", flexDirection:"column", gap:8 }}>
                  <Inp label={vendaCalc ? "PREÇO DOS PRODUTOS (R$)" : "VALOR COBRADO (R$)"} type="number" value={form.valor} onChange={e=>mudarPrecoProdutos(e.target.value)} placeholder={valorItensCalc.toFixed(2)} />
                  <div style={{ padding:"8px 10px", background:C.panel, borderRadius:8, border:"1px solid "+C.border, display:"flex", flexDirection:"column", gap:5 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <span style={{ color:C.muted, fontSize:10.5, fontWeight:600 }}>PREÇO DE VENDA</span>
                      <span style={{ color:C.text, fontWeight:800, fontSize:12.5 }}>R$ {precoVendaCalc.toFixed(2)}</span>
                    </div>
                    {vendaCalc && (
                      <>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                          <span style={{ color:C.muted, fontSize:10.5, fontWeight:600 }}>{canalForm?.icone} TAXAS E CUSTOS DA VENDA</span>
                          <span style={{ color:C.warning, fontWeight:800, fontSize:12.5 }}>− R$ {vendaCalc.custoVenda.toFixed(2)}</span>
                        </div>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                          <span style={{ color:C.muted, fontSize:10.5, fontWeight:600 }}>VOCÊ RECEBE</span>
                          <span style={{ color:C.success, fontWeight:800, fontSize:12.5 }}>R$ {vendaCalc.liquido.toFixed(2)}</span>
                        </div>
                      </>
                    )}
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <span style={{ color:C.muted, fontSize:10.5, fontWeight:600 }}>CUSTO</span>
                      <span style={{ color:C.warning, fontWeight:800, fontSize:12.5 }}>R$ {custoCalc.toFixed(2)}</span>
                    </div>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", borderTop:"1px solid "+C.border, paddingTop:5 }}>
                      <span style={{ color:C.muted, fontSize:10.5, fontWeight:700 }}>LUCRO</span>
                      <span style={{ color: lucroCalc>=0 ? C.success : C.danger, fontWeight:900, fontSize:13.5 }}>R$ {lucroCalc.toFixed(2)}</span>
                    </div>
                  </div>
                  <Btn onClick={()=>{ setModalSelecionarProduto(false); setBuscaProdutoForm(""); }} disabled={form.itens.length===0}>Usar produtos selecionados</Btn>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Modal cliente: cadastrar novo + vincular existente */}
      {modalNovoCliente && (
        <>
          <div onClick={()=>{setModalNovoCliente(false);setBuscaCliente("");setFormNovoCliente({nome:"",celular:"",instagram:""}); }} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:1000 }} />
          <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"min(460px,95vw)", background:C.panel, border:"1px solid "+withAlpha(C.accent, "44"), borderRadius:18, padding:20, zIndex:1001, boxShadow:"0 24px 64px rgba(0,0,0,0.7)", maxHeight:"90vh", display:"flex", flexDirection:"column", gap:14, overflow:"hidden" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexShrink:0 }}>
              <div style={{ fontWeight:900, fontSize:14, color:C.accent, letterSpacing:1 }}>👤 CLIENTE</div>
              <button onClick={()=>{setModalNovoCliente(false);setBuscaCliente("");setFormNovoCliente({nome:"",celular:"",instagram:""}); }} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>✕</button>
            </div>

            <div style={{ background:C.card, borderRadius:12, padding:14, border:"1px solid "+C.border, flexShrink:0 }}>
              <div style={{ color:C.accent2, fontSize:11, fontWeight:800, letterSpacing:1.5, marginBottom:10 }}>➕ CADASTRAR NOVO</div>
              <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                <input value={formNovoCliente.nome} onChange={e=>setFormNovoCliente(f=>({...f,nome:e.target.value}))} placeholder="Nome *"
                  style={{ background:C.panel, border:"1px solid "+C.border, borderRadius:8, color:C.text, padding:"8px 12px", fontSize:13, outline:"none" }} />
                <input value={formNovoCliente.celular} onChange={e=>setFormNovoCliente(f=>({...f,celular:e.target.value}))} placeholder="Telefone / WhatsApp"
                  style={{ background:C.panel, border:"1px solid "+C.border, borderRadius:8, color:C.text, padding:"8px 12px", fontSize:13, outline:"none" }} />
                <input value={formNovoCliente.instagram} onChange={e=>setFormNovoCliente(f=>({...f,instagram:e.target.value}))} placeholder="Instagram (opcional)"
                  style={{ background:C.panel, border:"1px solid "+C.border, borderRadius:8, color:C.text, padding:"8px 12px", fontSize:13, outline:"none" }} />
                <Btn onClick={cadastrarCliente} disabled={salvandoCliente}>
                  {salvandoCliente?"⏳ Cadastrando...":"✅ Cadastrar e vincular"}
                </Btn>
              </div>
            </div>

            <div style={{ display:"flex", flexDirection:"column", gap:8, overflow:"hidden", flex:1 }}>
              <div style={{ color:C.muted, fontSize:11, fontWeight:800, letterSpacing:1.5, flexShrink:0 }}>🔍 VINCULAR EXISTENTE</div>
              <input value={buscaCliente} onChange={e=>setBuscaCliente(e.target.value)} placeholder="Buscar por nome, telefone ou instagram..."
                style={{ background:C.card, border:"1px solid "+C.border, borderRadius:8, color:C.text, padding:"8px 12px", fontSize:13, outline:"none", flexShrink:0 }} />
              <div style={{ overflowY:"auto", flex:1, display:"flex", flexDirection:"column", gap:5 }}>
                {clientesFiltrados.length===0&&<div style={{ color:C.muted, textAlign:"center", padding:16, fontSize:13 }}>Nenhum cliente encontrado</div>}
                {clientesFiltrados.slice(0,10).map(c=>(
                  <button key={c.id} onClick={()=>vincularCliente(c)}
                    style={{ background:C.card, border:"1px solid "+C.border, borderRadius:10, padding:"10px 14px", cursor:"pointer", textAlign:"left" }}>
                    <div style={{ fontWeight:700, fontSize:13, color:C.text }}>{c.nome}</div>
                    <div style={{ fontSize:11, color:C.muted, marginTop:2, display:"flex", gap:10, flexWrap:"wrap" }}>
                      {c.celular&&<span>📱 {c.celular}</span>}
                      {c.instagram&&<span style={{color:"#e879f9"}}>📸 {c.instagram}</span>}
                      {c.aceitaWhatsapp&&<span style={{color:"#25d366"}}>✓ WhatsApp</span>}
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </>
      )}

      {/* Modal WhatsApp do pedido */}
      {waModal && (
        <>
          <div onClick={()=>setWaModal(null)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:1000 }} />
          <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"min(420px,94vw)", background:C.panel, border:"1px solid rgba(37,211,102,0.35)", borderRadius:18, padding:24, zIndex:1001, boxShadow:"0 24px 64px rgba(0,0,0,0.7)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
              <div>
                <div style={{ fontWeight:900, fontSize:15, color:"#25d366", letterSpacing:1 }}>💬 WHATSAPP</div>
                <div style={{ color:C.muted, fontSize:12, marginTop:4 }}>Para: <strong style={{ color:C.text }}>{waModal.cliente}</strong> · {waModal.cliente_celular}</div>
              </div>
              <button onClick={()=>setWaModal(null)} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>✕</button>
            </div>
            <textarea value={waMensagem} onChange={e=>setWaMensagem(e.target.value)} placeholder="Mensagem..." rows={4}
              style={{ width:"100%", background:C.card, border:"1px solid "+C.border, borderRadius:10, color:C.text, padding:"10px 12px", fontSize:13, resize:"vertical", outline:"none", fontFamily:"inherit", boxSizing:"border-box" }} />
            {waErro && <div style={{ color:C.danger, fontSize:12, marginTop:8 }}>⚠️ {waErro}</div>}
            {waOk   && <div style={{ color:"#25d366", fontSize:12, marginTop:8, fontWeight:700 }}>✅ Mensagem enviada!</div>}
            <div style={{ display:"flex", gap:8, marginTop:14 }}>
              <Btn onClick={enviarWaMensagem} disabled={waEnviando || waOk} style={{ flex:1, background:"linear-gradient(135deg,#25d366,#128c7e)", border:"none" }}>
                {waEnviando ? "⏳ Enviando..." : "📤 Enviar"}
              </Btn>
              <Btn outline onClick={()=>setWaModal(null)}>Cancelar</Btn>
            </div>
          </div>
        </>
      )}

      {/* Modal chat do pedido online */}
      {chatPedido && (
        <>
          <div onClick={()=>setChatPedido(null)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:1000 }} />
          <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"min(460px,95vw)", background:C.panel, border:"1px solid rgba(0,212,170,0.35)", borderRadius:18, padding:20, zIndex:1001, boxShadow:"0 24px 64px rgba(0,0,0,0.7)", display:"flex", flexDirection:"column", maxHeight:"90vh" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
              <div>
                <div style={{ fontWeight:900, fontSize:14, color:C.accent2, letterSpacing:1 }}>💬 CHAT DO PEDIDO</div>
                <div style={{ color:C.muted, fontSize:12, marginTop:3 }}>{chatPedido.cliente}</div>
              </div>
              <button onClick={()=>setChatPedido(null)} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>✕</button>
            </div>
            <ChatPedido vendedorId={chatPedido.vendedorOnlineId} pedidoId={chatPedido.pedidoOnlineId} autor="vendedor" altura={320} />
          </div>
        </>
      )}

      {/* Modal RECEBER pagamento (dinheiro / maquininha / Pix QR) */}
      {receberModal && (() => {
        let preview=receberModal;
        if(receberCupom) {try{preview=descontarPedido(receberModal,receberCupom,0);}catch{}}
        const pg = calcPagamento(preview);
        return (
        <>
          <div onClick={()=>{if(!recebendoRef.current)setReceberModal(null);}} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:1010 }} />
          {/* zIndex acima do popup de detalhe do pedido (1001) — o "Receber pagamento" é
              aberto de DENTRO dele, então precisa ficar por cima mesmo tendo o mesmo nível de DOM */}
          <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"min(440px,95vw)", background:C.panel, border:"1px solid "+withAlpha(C.accent2, "55"), borderRadius:18, padding:22, zIndex:1011, boxShadow:"0 24px 64px rgba(0,0,0,0.7)", maxHeight:"92vh", overflowY:"auto" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
              <div>
                <div style={{ fontWeight:900, fontSize:15, color:C.accent2, letterSpacing:1 }}>💵 RECEBER PAGAMENTO</div>
                <div style={{ color:C.muted, fontSize:12, marginTop:4 }}>{receberModal.cliente} · {receberModal.produto}</div>
              </div>
              <button disabled={recebendo} onClick={()=>setReceberModal(null)} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>✕</button>
            </div>

            <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:C.muted, background:C.card, border:"1px solid "+C.border, borderRadius:10, padding:"10px 12px", marginBottom:14 }}>
              <span>Total: <strong style={{ color:C.text }}>R$ {pg.total.toFixed(2)}</strong></span>
              <span>Pago: <strong style={{ color:C.success }}>R$ {pg.pago.toFixed(2)}</strong></span>
              <span>Falta: <strong style={{ color:C.warning }}>R$ {pg.saldo.toFixed(2)}</strong></span>
            </div>

            {receberModal.cupom ? <p style={{color:C.accent2,fontSize:12}}>Cupom {receberModal.cupom.codigo} já registrado · desconto de R$ {Number(receberModal.desconto || 0).toFixed(2)} incluído no total.</p> : <CupomVenda key={receberModal.id} subtotal={Number(receberModal.valor) || 0} cupom={receberCupom} onChange={selecionarCupomRecebimento} disabled={recebendo} />}
            {receberCupom && <p style={{fontSize:12,color:C.muted}}>Subtotal R$ {Number(receberModal.valor || 0).toFixed(2)} · desconto R$ {Number(preview.desconto || 0).toFixed(2)}. Será salvo junto com o recebimento.</p>}
            <label style={{ color:C.muted, fontSize:10, fontWeight:700, letterSpacing:1.5, display:"block", marginBottom:6 }}>VALOR A RECEBER (R$)</label>
            <input type="number" value={receberValor} onChange={e=>setReceberValor(e.target.value)} placeholder="0,00"
              style={{ width:"100%", boxSizing:"border-box", background:C.card, border:"1px solid "+C.border, borderRadius:10, color:C.success, fontSize:18, fontWeight:900, padding:"10px 14px", outline:"none", marginBottom:8 }} />
            <div style={{ display:"flex", gap:6, marginBottom:16 }}>
              <button disabled={recebendo} onClick={()=>setReceberValor(Math.min(pg.saldo,pg.total*0.5).toFixed(2))} style={{ flex:1, padding:"6px", borderRadius:8, fontSize:11, fontWeight:700, cursor:"pointer", background:"transparent", border:"1px solid "+C.warning, color:C.warning }}>50% (R$ {Math.min(pg.saldo,pg.total*0.5).toFixed(2)})</button>
              <button onClick={()=>setReceberValor(pg.saldo.toFixed(2))} style={{ flex:1, padding:"6px", borderRadius:8, fontSize:11, fontWeight:700, cursor:"pointer", background:"transparent", border:"1px solid "+C.success, color:C.success }}>Saldo (R$ {pg.saldo.toFixed(2)})</button>
            </div>

            <label style={{ color:C.muted, fontSize:10, fontWeight:700, letterSpacing:1.5, display:"block", marginBottom:6 }}>FORMA DE PAGAMENTO</label>
            <div style={{ display:"flex", gap:6, marginBottom:16, flexWrap:"wrap" }}>
              {[
                { id:"dinheiro", label:"💵 Dinheiro" },
                { id:"maquininha", label:"💳 Maquininha" },
                // Pix QR com a chave do vendedor: só com o PIX manual ativado em
                // Configurações e nenhum provedor conectado (com provedor, o Pix
                // dele confirma sozinho; o QR da chave não tem confirmação)
                ...(pixManualNosPedidos(pagamentoCfg, statusMP, statusPB, statusIP) ? [{ id:"pix", label:"📱 Pix QR" }] : []),
                // Com PagBank (ou InfinitePay) pronto, todos os provedores — inclusive o
                // Mercado Pago — ficam em "Cobrança online"; sem eles, nada muda
                ...(pagamentosExtrasHabilitados() && (statusPB?.conectado || statusIP?.configurada) ? [{ id:"online", label:"🌐 Cobrança online" }]
                  : mercadoPagoEmUso(pagamentoCfg, statusMP) ? [{ id:"mp_pix", label:"⚡ Pix Mercado Pago" }] : []),
              ].map(m=>(
                <button key={m.id} onClick={()=>setReceberMetodo(m.id)}
                  style={{ flex:1, padding:"10px 6px", borderRadius:10, fontSize:12, fontWeight:700, cursor:"pointer", background:receberMetodo===m.id?withAlpha(C.accent2, "22"):"transparent", border:"1px solid "+(receberMetodo===m.id?C.accent2:C.border), color:receberMetodo===m.id?C.accent2:C.muted }}>
                  {m.label}
                </button>
              ))}
            </div>

            {receberMetodo==="maquininha" && (
              <div style={{ fontSize:12, color:C.muted, lineHeight:1.6, background:"rgba(0,158,227,0.06)", border:"1px solid rgba(0,158,227,0.2)", borderRadius:10, padding:"12px 14px", marginBottom:16 }}>
                💳 Passe o valor de <strong style={{ color:C.text }}>R$ {(parseFloat(receberValor)||0).toFixed(2)}</strong> na maquininha. Após aprovado, confirme abaixo para registrar o recebimento.
              </div>
            )}

            {receberMetodo==="pix" && (
              <div style={{ marginBottom:16, textAlign:"center" }}>
                {!pagamentoCfg.pixChave ? (
                  <div style={{ fontSize:12, color:C.warning, lineHeight:1.6, background:"rgba(245,158,11,0.08)", border:"1px solid rgba(245,158,11,0.25)", borderRadius:10, padding:"12px 14px", textAlign:"left" }}>
                    ⚠️ Nenhuma chave Pix configurada. Vá em <strong>Configurações → Pagamentos → PIX</strong> e cadastre sua chave para gerar o QR Code.
                  </div>
                ) : receberQr ? (
                  <>
                    <div style={{ fontSize:11, color:C.muted, marginBottom:8 }}>Mostre o QR Code para o cliente escanear:</div>
                    <img src={receberQr} alt="QR Code Pix" style={{ width:220, height:220, borderRadius:12, background:"#fff", padding:8, boxSizing:"border-box" }} />
                    <button onClick={copiarPix} style={{ marginTop:10, width:"100%", padding:"9px", borderRadius:10, fontSize:12, fontWeight:700, cursor:"pointer", background:"transparent", border:"1px solid "+C.accent2, color:C.accent2 }}>📋 Copiar código Pix (copia e cola)</button>
                  </>
                ) : (
                  <div style={{ fontSize:12, color:C.muted, padding:20 }}>⏳ Gerando QR Code...</div>
                )}
              </div>
            )}

            {/* Pix Mercado Pago: quem registra o pagamento é o servidor, depois de
                confirmar com o Mercado Pago — aqui não existe "confirmar" manual. */}
            {receberMetodo==="mp_pix" && (
              <PixMercadoPago pedido={data.find(d=>d.id===receberModal.id) || receberModal} conectado={!!statusMP?.conectado}
                onPago={()=>setTimeout(()=>setReceberModal(null), 1500)} />
            )}

            {/* Cobrança online (Mercado Pago, PagBank, InfinitePay): o servidor
                confirma com o provedor e registra — sem "confirmar" manual. */}
            {receberMetodo==="online" && (
              <CobrancaOnline pedido={data.find(d=>d.id===receberModal.id) || receberModal}
                disponiveis={[
                  ...(mercadoPagoEmUso(pagamentoCfg, statusMP) ? ["mercadopago"] : []),
                  ...(statusPB?.conectado ? ["pagbank"] : []),
                  ...(statusIP?.configurada ? ["infinitepay"] : []),
                ]}
                onPago={()=>setTimeout(()=>setReceberModal(null), 1500)} />
            )}

            {receberMetodo!=="mp_pix" && receberMetodo!=="online" && <Btn onClick={confirmarRecebimento} disabled={recebendo} color={C.success} style={{ width:"100%" }}>
              {recebendo ? "Registrando…" : `✅ Confirmar recebimento de R$ ${(parseFloat(receberValor)||0).toFixed(2)}`}
            </Btn>}
          </div>
        </>
        );
      })()}



      {resumoDetalhe && (() => {
        // Busca a versão mais atual do pedido em `data` (que é atualizado em tempo real
        // pelo fbWatch) em vez do snapshot estático guardado ao abrir o popup — assim o
        // status reflete na hora, sem precisar fechar e reabrir o popup.
        const p = data.find(d => d.id === resumoDetalhe.id) || resumoDetalhe;
        const custo = calcCustoPedido(p, impressoras, produtos);
        const custoCard = custo.total;
        const lucro = p.valor ? parseFloat(p.valor)-custoCard : null;
        const pg = calcPagamento(p);
        const online = ehVendaOnline(p.venda_online);
        const si = statusInfo(p.status);
        const prox = proximoStatus(p.status);
        const proxInfo = prox ? statusInfo(prox) : null;
        const pesoTotal = (p.filamentos_usados||[]).reduce((s,f)=>s+(parseFloat(f.peso)||0),0) || (parseFloat(p.peso)||0);
        const primFil = filamentos.find(f=>f.id===p.filamento_id)||(p.filamentos_usados||[])[0]?.id?filamentos.find(f=>f.id===(p.filamentos_usados||[])[0]?.id):null;
        const corFil = primFil ? corHex(primFil.cor) : null;
        const produtosDoPedido = itensComFoto(p, produtos);
        const aggInfo = produtosDoPedido.map(it => {
          const prod = produtos.find(pr=>pr.id===it.produto_id);
          const pesoOrig = (prod?.filamentos_usados||[]).reduce((s,f)=>s+(parseFloat(f.peso)||0),0);
          const peso = (it.peso!=null && it.peso!=="") ? parseFloat(it.peso) : pesoOrig;
          const horas = (it.horas_impressao!=null && it.horas_impressao!=="") ? parseFloat(it.horas_impressao) : (parseFloat(prod?.horas_impressao)||0);
          return { peso, horas, qtd: parseInt(it.qtd)||1, filamentos: prod?.filamentos_usados||[] };
        });
        const tempoTotal = aggInfo.reduce((s,x)=>s+x.horas*x.qtd,0) || (parseFloat(p.horas_impressao)||0);
        const pesoTotalAgg = aggInfo.reduce((s,x)=>s+x.peso*x.qtd,0) || pesoTotal;
        const filamentosTxt = [...new Set(aggInfo.flatMap(x=>x.filamentos.map(f=>f.nome||f.cor)).filter(Boolean))].join(", ")
          || (p.filamentos_usados||[]).map(f=>f.nome).join(", ") || p.filamento_nome || "—";
        const fechar = () => setResumoDetalhe(null);
        return (
          <CommerceDialog title="Detalhes do pedido" subtitle={p.cliente || "Cliente não informado"} onClose={fechar} footer={<>
            <details className="commerce-secondary"><summary>Mais ações</summary>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:14 }}>
                {p.pedidoOnlineId && (
                  <button onClick={()=>{ fechar(); setChatPedido(p); }}
                    title="Chat do pedido (loja online)"
                    style={{ background:"rgba(0,212,170,0.12)", border:"1px solid rgba(0,212,170,0.3)", borderRadius:8, color:C.accent2, fontSize:12, padding:"6px 10px", cursor:"pointer" }}>
                    🗨️ Chat
                  </button>
                )}
                {p.cliente_celular && (
                  <button onClick={()=>{ fechar(); setWaModal(p); setWaErro(""); setWaOk(false); setWaMensagem(p.status==="Pronto"?`Olá ${p.cliente}! 🎉 Seu pedido "${p.produto}" está pronto para retirada. Entre em contato para combinar a entrega!`:""); }}
                    title="Enviar WhatsApp"
                    style={{ background:"rgba(37,211,102,0.12)", border:"1px solid rgba(37,211,102,0.3)", borderRadius:8, color:"#25d366", fontSize:12, padding:"6px 10px", cursor:"pointer" }}>
                    💬 WhatsApp
                  </button>
                )}
                {si.id === "imprimindo" && <button onClick={()=>{ fechar(); setPerdaForm({ motivo:"", peso:"", tempo:"", valor:"" }); setPerdaPedido(p); }}
                  style={{ background:"rgba(239,68,68,0.08)", border:"1px solid rgba(239,68,68,0.3)", borderRadius:8, color:C.danger, fontSize:12, padding:"6px 10px", cursor:"pointer", fontWeight:700 }}>
                  ⚠️ Adicionar perdas
                </button>}
                {podeExcluirPedido(p)
                  ? <Btn small danger disabled={!!busyId} onClick={()=>{ fechar(); del(p.id); }}>🗑️ Excluir rascunho</Btn>
                  : <>
                    {si.id !== "cancelado" && <Btn small danger disabled={!!busyId} onClick={()=>cancelarPedido(p)}>Cancelar pedido</Btn>}
                    <p className="commerce-hint">Este pedido mantém seu histórico. {si.id === "cancelado" ? "Já está cancelado." : "Use Cancelar pedido para encerrar a venda."} {pg.pago > 0 && "Para devolver o valor registrado, use Estornar na aba Pagamentos."}</p>
                  </>}
              </div>

            </details>
            <Btn small outline onClick={()=>{ fechar(); edit(p); }}>Editar pedido</Btn>
            {si.id !== "cancelado" && !pg.quitado && pg.total > 0 && (online
              ? <Btn small color={C.accent} onClick={()=>{ fechar(); setRepasseModal(p); }}>Confirmar repasse</Btn>
              : <Btn small color={C.accent2} onClick={()=>{ fechar(); abrirReceber(p); }}>Receber pagamento</Btn>)}
          </>}>
            <CommerceTabs>
              <CommercePanel label="Resumo">
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14, gap:10 }}>
                <div style={{ display:"flex", gap:14, alignItems:"flex-start" }}>
                  <CarrosselProdutos itens={produtosDoPedido} />
                  <div>
                    <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", marginBottom:4 }}>
                      <span style={{ fontWeight:900, fontSize:16, color:C.text }}>{p.produto}</span>
                      <Badge color={si.cor}>{si.icone} {si.label}</Badge>
                      {online
                        ? <Badge color={C.accent}>{iconeCanal(p.venda_online.canal)} {p.venda_online.canal_nome}</Badge>
                        : p.origem==="site" && <Badge color="var(--pc-ui-0ea5e9, #0ea5e9)">🌐 Site</Badge>}
                      {pg.total>0 && (pg.quitado
                        ? <Badge color={C.success}>💰 Pago</Badge>
                        : pg.pago>0 ? <Badge color={C.warning}>💰 {pg.pct}% pago</Badge> : null)}
                    </div>
                    <div style={{ color:C.muted, fontSize:12, display:"flex", gap:10, flexWrap:"wrap" }}>
                      <span>👤 {p.cliente}</span>
                      {p.data && <span>📅 {p.data}</span>}
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10, margin:"10px 0", padding:"10px 0", borderTop:"1px dashed "+C.border, borderBottom:"1px dashed "+C.border }}>
                <div>
                  {p.valor && <span style={{ color:C.success, fontWeight:900, fontSize:18 }}>R$ {parseFloat(p.valor).toFixed(2)}</span>}
                  {lucro!==null && <div style={{ color:lucro>=0?C.accent2:C.danger, fontSize:12, fontWeight:700 }}>Lucro: R$ {lucro.toFixed(2)}</div>}
                </div>
                <div style={{ display:"flex", gap:4, alignItems:"center", flexWrap:"wrap" }}>
                  {proxInfo && (
                    <button disabled={!!busyId} onClick={()=>mudarStatus(p, prox)} title={"Avançar para "+proxInfo.label}
                      style={{ padding:"5px 10px", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer", background:proxInfo.cor, border:"1px solid "+proxInfo.cor, color:"#fff", whiteSpace:"nowrap" }}>
                      {proxInfo.icone} {proxInfo.curto} →
                    </button>
                  )}
                  <select disabled={!!busyId} aria-label="Mudar etapa do pedido" value={si.id} onChange={e=>mudarStatus(p, e.target.value)} title="Mudar status"
                    style={{ background:C.bg, border:"1px solid "+C.border, borderRadius:6, color:si.cor, fontSize:11, fontWeight:700, padding:"5px 7px", outline:"none", cursor:"pointer" }}>
                    {STATUS_PEDIDO.map(s=><option key={s.id} value={s.id} style={{ color:C.text }}>{s.icone} {s.label}</option>)}
                  </select>
                </div>
              </div>

                <div className="commerce-section">
                  <h3>Pagamento</h3>
                  <div className="quote-metric"><span>{online ? "Recebido no caixa" : "Recebido"}</span><strong>R$ {(online ? pagoNoCaixa(p, pg.pago) : pg.recebido).toFixed(2)}</strong></div>
                  <div className="quote-metric"><span>{online ? "Repasse previsto a receber" : "Saldo a receber"}</span><strong>R$ {(online ? repassePrevisto(p) : pg.saldo).toFixed(2)}</strong></div>
                </div>
                <ResumoVendaOnline vo={p.venda_online} />
                {p.previsao_entrega && <p className="commerce-hint">Previsão de entrega: {fmtData(p.previsao_entrega)}</p>}
                {p.obs && <p className="commerce-hint">{p.obs}</p>}
              </CommercePanel>
              <CommercePanel label="Itens e produção">
              <EditorProdutosPedido pedido={p} produtos={produtos} impressoras={impressoras} filamentos={filamentos} corHex={corHex} onSalvar={(itens)=>salvarItensPedido(p, itens)} />

                <details className="quote-more"><summary>Materiais e arquivos de impressão</summary>
              {(p.filamentos_usados||[]).length>0
                ? <div style={{ fontSize:12, color:C.muted, marginBottom:6 }}>🧵 {p.filamentos_usados.map(f=>`${f.peso}g ${f.nome}`).join(" + ")}</div>
                : corFil && <div style={{ fontSize:12, color:C.muted, marginBottom:6, display:"flex", alignItems:"center", gap:4 }}><div style={{ width:10, height:10, borderRadius:3, background:corFil }} />{p.filamento_nome}</div>}
              {p.impressora_nome && <div style={{ fontSize:12, color:C.muted, marginBottom:6 }}>🖨️ {p.impressora_nome}</div>}
              {(p.itens||[]).length>0 && <div style={{ marginBottom:8, display:"flex", flexWrap:"wrap", gap:4 }}>{p.itens.map(it=><span key={it.produto_id} style={{ background:withAlpha(C.accent, "18"), border:"1px solid "+withAlpha(C.accent, "44"), borderRadius:5, padding:"2px 7px", fontSize:11, color:C.accent }}>{it.qtd}× {it.nome}</span>)}</div>}
              {(() => {
                const arquivos3mf = produtosDoPedido.flatMap(it => {
                  const prod = produtos.find(pr=>pr.id===it.produto_id);
                  return (prod?.arquivos||[])
                    .filter(a => (a.nome||"").toLowerCase().endsWith(".3mf"))
                    .map(a => ({ ...a, chave: `${it.produto_id}_${a.path}` }));
                });
                if (arquivos3mf.length===0) return null;
                return (
                  <div style={{ marginBottom:10, display:"flex", flexDirection:"column", gap:6 }}>
                    <div style={{ color:C.muted, fontSize:11, fontWeight:700, letterSpacing:1 }}>📦 ARQUIVOS 3MF</div>
                    {arquivos3mf.map(a => (
                      <div key={a.chave} style={{ display:"flex", alignItems:"center", gap:6, background:C.card, border:"1px solid "+C.border, borderRadius:8, padding:"6px 10px" }}>
                        <span style={{ color:C.text, fontSize:12, flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{a.nome}</span>
                        <button onClick={() => baixarArquivo(a.url, a.nome)} title="Baixar .3mf"
                          style={{ background:withAlpha(C.accent2, "22"), border:"1px solid "+withAlpha(C.accent2, "44"), borderRadius:6, color:C.accent2, cursor:"pointer", padding:"3px 9px", fontSize:11, fontWeight:700 }}>
                          ⬇ Baixar
                        </button>
                        {window.electronAPI?.isElectron && (
                          <button onClick={() => abrirNoBambuStudio(a.url, a.nome)} title="Abrir direto no Bambu Studio"
                            style={{ background:"color-mix(in srgb, var(--pc-ui-f59e0b, #f59e0b) 13.33%, transparent)", border:"1px solid color-mix(in srgb, var(--pc-ui-f59e0b, #f59e0b) 26.67%, transparent)", borderRadius:6, color:"var(--pc-ui-f59e0b, #f59e0b)", cursor:"pointer", padding:"3px 9px", fontSize:11, fontWeight:700, whiteSpace:"nowrap" }}>
                            🧊 Bambu Studio
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                );
              })()}
              {p.materiais_usados?.length>0 && <div style={{ marginBottom:8, display:"flex", flexWrap:"wrap", gap:4 }}>{p.materiais_usados.map(m=><span key={m.id} style={{ background:"#e879f922", border:"1px solid #e879f944", borderRadius:5, padding:"2px 7px", fontSize:11, color:"#e879f9" }}>{m.qtd} {m.unidade} {m.nome}</span>)}</div>}
              {p.obs && <div style={{ color:C.muted, fontSize:12, marginBottom:8 }}>📝 {p.obs}</div>}

                </details>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(110px,1fr))", gap:8, margin:"14px 0" }}>
                <Detalhe rotulo="⏱️ Tempo" valor={tempoTotal?`${tempoTotal}h`:"—"} />
                <Detalhe rotulo="⚖️ Peso" valor={pesoTotalAgg?`${pesoTotalAgg.toFixed(0)}g`:"—"} />
                <Detalhe rotulo="🧵 Filamento" valor={filamentosTxt} />
                <Detalhe rotulo="🖨️ Impressora" valor={p.impressora_nome||"—"} />
                <Detalhe rotulo="📅 Criado" valor={p.data||fmtData(p.created_at)} />
                <Detalhe rotulo="📉 Estoque" valor={p.estoque_baixado===true?"Baixado ✓":p.estoque_baixado===false?"Baixa ao imprimir":"—"} cor={p.estoque_baixado===true?C.success:undefined} />
                <Detalhe rotulo="📦 Custo" valor={`R$ ${custoCard.toFixed(2)}`} cor={C.text} />
                {lucro!==null && <Detalhe rotulo="📈 Lucro" valor={`R$ ${lucro.toFixed(2)}`} cor={lucro>=0?C.success:C.danger} />}
              </div>

              {custoCard>0 && (
                <div style={{ display:"flex", gap:14, flexWrap:"wrap", fontSize:11, color:C.muted, marginBottom:14 }}>
                  {custo.cFil>0 && <span>🧵 Filamento R$ {custo.cFil.toFixed(2)}</span>}
                  {(custo.cEn+custo.cDes)>0 && <span>🖨️ Impressão R$ {(custo.cEn+custo.cDes).toFixed(2)}</span>}
                  {custo.cMat>0 && <span>🔧 Materiais R$ {custo.cMat.toFixed(2)}</span>}
                  {custo.cMO>0 && <span>🙌 Mão de obra R$ {custo.cMO.toFixed(2)}</span>}
                  {custo.cItens>0 && <span>📦 Itens R$ {custo.cItens.toFixed(2)}</span>}
                  {custo.cVenda>0 && <span>🛒 Taxas e custos da venda R$ {custo.cVenda.toFixed(2)}</span>}
                </div>
              )}

              </CommercePanel>
              <CommercePanel label="Pagamentos">
                <h3 style={{fontSize:15, margin:"0 0 20px"}}>Recebimentos do pedido</h3>
                {p.cupom?.codigo && <p style={{fontSize:12,color:C.accent2,lineHeight:1.6}}>Cupom <strong>{p.cupom.codigo}</strong> · subtotal R$ {Number(p.subtotal || 0).toFixed(2)} · desconto R$ {Number(p.desconto || 0).toFixed(2)} · total R$ {pg.total.toFixed(2)}</p>}
              {pg.total>0 && (
                <div style={{ marginBottom:14 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, marginBottom:6, flexWrap:"wrap", gap:6 }}>
                    <span style={{ color:C.muted }}>Pago <strong style={{ color:pg.quitado?C.success:C.warning }}>R$ {pg.pago.toFixed(2)}</strong> de R$ {pg.total.toFixed(2)}</span>
                    {!pg.quitado && <span style={{ color:C.warning, fontWeight:700 }}>Falta R$ {pg.saldo.toFixed(2)}</span>}
                  </div>
                  <div style={{ height:6, background:C.bg, borderRadius:3, overflow:"hidden", marginBottom:8 }}>
                    <div style={{ height:"100%", width:`${pg.pct}%`, background:pg.quitado?C.success:C.warning, borderRadius:3, transition:"width .3s" }} />
                  </div>
                  <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                    {!pg.quitado && online && <button onClick={()=>{ fechar(); setRepasseModal(p); }} title="A loja depositou: registra o que caiu e o que ela reteve" style={{ padding:"4px 10px", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer", background:C.accent, border:"1px solid "+C.accent, color:"#fff" }}>🛒 Confirmar repasse</button>}
                    {si.id !== "cancelado" && !pg.quitado && !online && <button onClick={()=>{ fechar(); abrirReceber(p); }} title="Receber pagamento (Pix QR, maquininha ou dinheiro)" style={{ padding:"4px 10px", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer", background:C.accent2, border:"1px solid "+C.accent2, color:"#fff" }}>💵 Receber</button>}
                    {si.id !== "cancelado" && !pg.quitado && !online && <button onClick={()=>registrarPagamento(p, pg.saldo*0.5)} title="Registrar metade do saldo restante" style={{ padding:"4px 9px", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer", background:"transparent", border:"1px solid "+C.warning, color:C.warning }}>50% do saldo</button>}
                    {si.id !== "cancelado" && !pg.quitado && !online && <button onClick={()=>registrarPagamento(p, pg.saldo)} title="Quitar o saldo restante" style={{ padding:"4px 9px", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer", background:C.success, border:"1px solid "+C.success, color:"#fff" }}>✅ Quitar</button>}
                    {pg.pago>0 && <button onClick={()=>estornarPagamentos(p)} title="Estornar pagamentos" style={{ padding:"4px 8px", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer", background:"transparent", border:"1px solid "+C.border, color:C.muted }}>↺ Estornar</button>}
                  </div>
                  {(p.pagamentos||[]).length>0 && (
                    <div style={{ display:"flex", flexDirection:"column", gap:3, marginTop:8 }}>
                      {(p.pagamentos||[]).map((pay,idx)=>(
                        <div key={pay.id||idx} style={{ display:"flex", alignItems:"center", gap:8, fontSize:11 }}>
                          <span style={{ color:pay.retido?C.warning:C.success, fontWeight:700 }} title={pay.retido?"Ficou com a loja — não entrou no caixa":undefined}>{pay.retido?"↳":"+"} R$ {(parseFloat(pay.valor)||0).toFixed(2)}</span>
                          {pay.metodo && pay.metodo!=="manual" && <span style={{ color:C.muted }}>{pay.metodo}</span>}
                          <span style={{ color:"var(--pc-ui-334155, #334155)", marginLeft:"auto" }}>{fmtDataHora(pay.em)}{pay.por&&pay.por!=="—"?` · ${pay.por}`:""}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

                {pg.total <= 0 && <p className="commerce-hint">{pg.quitado ? "Pedido quitado pelo desconto integral do cupom." : "Defina o valor do pedido para registrar pagamentos."}</p>}
              </CommercePanel>
              <CommercePanel label="Histórico">
              <div>
                <div style={{ fontSize:11, fontWeight:700, color:C.muted, marginBottom:6, letterSpacing:0.5 }}>🕓 HISTÓRICO</div>
                {(() => {
                  const hist = [...(p.historico||[])].reverse();
                  return hist.length===0 ? (
                    <div style={{ fontSize:11, color:C.muted, opacity:0.7 }}>Sem alterações registradas ainda.</div>
                  ) : (
                    <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
                      {hist.map((h,idx)=>(
                        <div key={idx} style={{ display:"flex", alignItems:"center", gap:8, fontSize:11, flexWrap:"wrap" }}>
                          {h.tipo==="pagamento" ? (
                            <span style={{ color:C.success, fontWeight:700 }}>💰 Pagamento R$ {(parseFloat(h.valor)||0).toFixed(2)}{h.metodo&&h.metodo!=="manual"?` (${h.metodo})`:""}</span>
                          ) : h.tipo==="desconto" ? (
                            <span style={{color:C.accent2,fontWeight:700}}>Cupom {h.cupom} · desconto R$ {Number(h.valor || 0).toFixed(2)}</span>
                          ) : h.tipo==="repasse" ? (
                            <span style={{ color:C.success, fontWeight:700 }}>🛒 Repasse {h.canal} R$ {(parseFloat(h.valor)||0).toFixed(2)}{h.retido>0?<span style={{ color:C.warning }}> · retido R$ {(parseFloat(h.retido)||0).toFixed(2)}</span>:null}</span>
                          ) : h.tipo==="falha" ? (
                            <span style={{ color:C.warning, fontWeight:700 }}>Falha de impressão: {h.motivo || "Não informado"}. Pedido devolvido à fila.</span>
                          ) : h.tipo==="estorno" ? (
                            <span style={{ color:C.danger, fontWeight:700 }}>↺ Pagamentos estornados</span>
                          ) : (
                            <>
                              <span style={{ color:statusInfo(h.para).cor, fontWeight:700 }}>{statusInfo(h.para).icone} {statusInfo(h.para).label}</span>
                              {h.de && <span style={{ color:C.muted }}>← {statusInfo(h.de).label}</span>}
                            </>
                          )}
                          <span style={{ color:"var(--pc-ui-334155, #334155)", marginLeft:"auto" }}>{fmtDataHora(h.em)}{h.por&&h.por!=="—"?` · ${h.por}`:""}</span>
                        </div>
                      ))}
                    </div>
                  );
                })()}
              </div>
              </CommercePanel>
            </CommerceTabs>
          </CommerceDialog>
        );
      })()}

      {repasseModal && (() => {
        const p = data.find(d => d.id === repasseModal.id) || repasseModal;
        return <ModalRepasse key={p.id} pedido={p} saldo={calcPagamento(p).saldo} enviando={recebendo}
          onConfirmar={(valor, lancarCustos)=>confirmarRepasse(p, valor, lancarCustos)} onFechar={()=>setRepasseModal(null)} />;
      })()}

      {modalProntosPedidos && (
        <>
          <div onClick={()=>setModalProntosPedidos(false)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:1000 }} />
          <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"min(440px,95vw)", background:C.panel, border:"1px solid #10b981", borderRadius:18, padding:20, zIndex:1001, boxShadow:"0 24px 64px rgba(0,0,0,0.7)", maxHeight:"80vh", display:"flex", flexDirection:"column", gap:12 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexShrink:0 }}>
              <div style={{ fontWeight:900, fontSize:14, color:C.text, letterSpacing:1 }}>📦 PRONTOS PRA ENTREGA</div>
              <button onClick={()=>setModalProntosPedidos(false)} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>✕</button>
            </div>
            <div style={{ overflowY:"auto", display:"flex", flexDirection:"column", gap:6 }}>
              {pedidosProntos.map(p => {
                const si = statusInfo(p.status);
                return (
                  <button key={p.id} onClick={()=>{ setModalProntosPedidos(false); setResumoDetalhe(p); }}
                    style={{ background:C.bg, border:"1px solid "+C.border, borderRadius:10, padding:"10px 12px", cursor:"pointer", textAlign:"left", display:"flex", justifyContent:"space-between", alignItems:"center", gap:8 }}>
                    <div style={{ minWidth:0 }}>
                      <div style={{ fontSize:13, fontWeight:700, color:C.text, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{p.produto}</div>
                      <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>👤 {p.cliente}</div>
                    </div>
                    <span style={{ fontSize:10, fontWeight:700, color:si.cor, background:withAlpha(si.cor, "18"), border:"1px solid "+withAlpha(si.cor, "44"), borderRadius:8, padding:"3px 9px", whiteSpace:"nowrap", flexShrink:0 }}>{si.icone} {si.curto}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}

      {modalOutrosPedidos && (
        <>
          <div onClick={()=>setModalOutrosPedidos(false)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:1000 }} />
          <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"min(440px,95vw)", background:C.panel, border:"1px solid "+C.border, borderRadius:18, padding:20, zIndex:1001, boxShadow:"0 24px 64px rgba(0,0,0,0.7)", maxHeight:"80vh", display:"flex", flexDirection:"column", gap:12 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexShrink:0 }}>
              <div style={{ fontWeight:900, fontSize:14, color:C.text, letterSpacing:1 }}>📋 OUTROS PEDIDOS</div>
              <button onClick={()=>setModalOutrosPedidos(false)} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>✕</button>
            </div>
            <div style={{ overflowY:"auto", display:"flex", flexDirection:"column", gap:6 }}>
              {pedidosOutros.map(p => {
                const si = statusInfo(p.status);
                return (
                  <button key={p.id} onClick={()=>{ setModalOutrosPedidos(false); setResumoDetalhe(p); }}
                    style={{ background:C.bg, border:"1px solid "+C.border, borderRadius:10, padding:"10px 12px", cursor:"pointer", textAlign:"left", display:"flex", justifyContent:"space-between", alignItems:"center", gap:8 }}>
                    <div style={{ minWidth:0 }}>
                      <div style={{ fontSize:13, fontWeight:700, color:C.text, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{p.produto}</div>
                      <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>👤 {p.cliente}</div>
                    </div>
                    <span style={{ fontSize:10, fontWeight:700, color:si.cor, background:withAlpha(si.cor, "18"), border:"1px solid "+withAlpha(si.cor, "44"), borderRadius:8, padding:"3px 9px", whiteSpace:"nowrap", flexShrink:0 }}>{si.icone} {si.curto}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}

    </div>
  );
}
